// Multilingual dictionary for MIHOD PAY (Verrouillé)
// French is the default/source language. Fallback order: chosen lang -> fr -> key.

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ro", label: "Română", flag: "🇷🇴" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "uk", label: "Українська", flag: "🇺🇦" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "bn", label: "বাংলা", flag: "🇧🇩" },
  { code: "id", label: "Indonesia", flag: "🇮🇩" },
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
];

export const translations = {
  fr: {
    "common.loading": "Chargement…",
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.send": "Envoyer",
    "common.close": "Fermer",
    "common.delete": "Supprimer",
    "common.subscribe": "S'abonner",
    "common.subscribed": "Abonné",
    "common.unlock": "Déverrouiller",
    "common.locked": "Verrouillée",
    "common.unlocked": "Déverrouillée",
    "common.photo": "Photo",
    "common.video": "Vidéo",
    "common.publish": "Publier",
    "common.translate": "Traduire",
    "common.showOriginal": "Voir l'original",
    "common.pleaseWait": "Veuillez patienter…",

    "nav.home": "Accueil",
    "nav.friends": "Amis",
    "nav.send": "Envoyer",
    "nav.wallet": "Portefeuille",
    "nav.profile": "Profil",
    "nav.wall": "Mon mur",

    "auth.login": "Connexion",
    "auth.register": "Inscription",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.username": "Pseudo",
    "auth.signIn": "Se connecter",
    "auth.createAccount": "Créer mon compte",
    "auth.age": "Je confirme avoir 18 ans ou plus et j'accepte les Conditions d'utilisation et les règles de contenu.",
    "auth.idUpload": "Pièce d'identité (vérification d'âge)",
    "auth.idUploadHint": "Obligatoire pour l'inscription. Utilisée pour la modération 18+.",
    "auth.idAdd": "Ajouter ma pièce d'identité",
    "auth.idAdded": "Pièce d'identité ajoutée",
    "auth.forgot": "Mot de passe oublié ?",
    "auth.reset": "Réinitialiser le mot de passe",
    "auth.resetHint": "Entrez votre email pour recevoir un lien de réinitialisation.",
    "auth.newPassword": "Nouveau mot de passe",
    "auth.backToLogin": "Retour à la connexion",
    "auth.welcome": "Bienvenue sur MIHOD PAY !",
    "auth.tagline": "Partagez des photos privées. Fixées à votre prix.",
    "auth.subtitle": "Envoyez une photo verrouillée à un ami. Elle ne se débloque qu'après paiement — et vous touchez 80 % de chaque vente.",
    "auth.ageError": "Vous devez confirmer avoir 18 ans ou plus.",
    "auth.idError": "Veuillez ajouter une pièce d'identité.",
    "auth.onlyAdults": "Réservé aux 18 ans et plus.",

    "home.yourBalance": "Votre solde",
    "home.recharge": "Recharger",
    "home.received": "Photos reçues",
    "home.noPhotos": "Aucune photo pour le moment",
    "home.noPhotosHint": "Ajoutez des amis pour recevoir des photos verrouillées.",
    "home.findFriends": "Trouver des amis",
    "home.count": "publication(s)",

    "explore.title": "Explorer",
    "explore.searchPlaceholder": "Rechercher créateurs, #hashtags, sons…",
    "explore.creators": "Créateurs",
    "explore.hashtags": "Hashtags",
    "explore.sounds": "Sons",
    "explore.trendingTags": "Hashtags tendances",
    "explore.trendingSounds": "Sons tendances",
    "explore.suggested": "Créateurs suggérés",
    "explore.noResults": "Aucun résultat",

    "profile.title": "Profil",
    "profile.balance": "Solde",
    "profile.earnings": "Revenus",
    "profile.sold": "Vendues",
    "profile.private": "Compte privé",
    "profile.privateDesc": "Seuls vos amis peuvent vous envoyer des photos.",
    "profile.creatorSub": "Abonnement créateur",
    "profile.creatorSubDesc": "Accès mensuel à toutes vos photos (formules Stripe).",
    "profile.locked": "Verrouillé",
    "profile.subGate": "Débloqué à partir de",
    "profile.subscribers": "abonnés — vous en avez",
    "profile.language": "Langue",
    "profile.languageDesc": "Choisissez la langue de l'interface.",
    "profile.avatarChange": "Changer la photo",
    "profile.publications": "Publications",
    "profile.photosPublished": "Photos",
    "profile.videosPublished": "Vidéos",
    "profile.myWall": "Voir mon mur public",
    "profile.subscribersCount": "Abonnés",
    "profile.mySubs": "Mes abonnements",
    "profile.yourSubscribers": "Vos abonnés",
    "profile.blocked": "Utilisateurs bloqués",
    "profile.noBlocked": "Aucun utilisateur bloqué.",
    "profile.unblock": "Débloquer",
    "profile.tos": "Conditions d'utilisation",
    "profile.safety": "Sécurité & modération",
    "profile.logout": "Se déconnecter",
    "profile.kycPending": "Vérification d'identité en attente",
    "profile.kycApproved": "Identité vérifiée",
    "account.title": "Modifier le compte",
    "account.desc": "Mettez à jour votre pseudo, votre email ou votre mot de passe.",
    "account.edit": "Modifier",
    "account.info": "Informations",
    "account.currentPassword": "Mot de passe actuel",
    "account.saveInfo": "Enregistrer",
    "account.changePassword": "Changer le mot de passe",
    "account.infoSaved": "Compte mis à jour",
    "account.passwordChanged": "Mot de passe modifié",

    "send.title": "Envoyer un média",
    "send.recipient": "Destinataire",
    "send.noFriends": "Aucun ami disponible",
    "send.add": "Ajouter",
    "send.media": "Média",
    "send.choosePhoto": "Choisir une photo ou vidéo",
    "send.formats": "JPG, PNG, MP4 • photo max 8 Mo",
    "send.changeMedia": "Changer de média",
    "send.willLock": "Sera verrouillé à",
    "send.price": "Prix de déblocage",
    "send.youEarn": "Vous toucherez",
    "send.caption": "Légende (facultatif)",
    "send.captionPlaceholder": "Ajoutez un message…",
    "send.submit": "Envoyer le média verrouillé",
    "send.sending": "Envoi…",
    "send.noMax": "Aucune limite de prix — minimum 1 €",

    "conv.start": "Débutez la conversation ou envoyez une photo verrouillée.",
    "conv.write": "Écrire un message…",
    "conv.requestPhoto": "Demander une photo",
    "conv.sendPhoto": "Envoyer une photo",
    "conv.translating": "Traduction…",

    "wall.title": "Mon mur créateur",
    "wall.subtitle": "Publiez des photos et vidéos payantes visibles par tous.",
    "wall.publish": "Nouvelle publication",
    "wall.publishTo": "Publier sur mon mur",
    "wall.empty": "Aucune publication pour l'instant.",
    "wall.emptyHint": "Ajoutez votre première photo ou vidéo payante.",
    "wall.visitVitrine": "Voir ma page vitrine",
    "wall.published": "Publication ajoutée à votre mur",
    "wall.creatorPage": "Page créateur",
    "wall.posts": "publications",
    "wall.subscribeToUnlock": "Abonnez-vous pour tout débloquer",
    "wall.notFound": "Créateur introuvable",
    "wall.by": "Publications de",

    "wallet.title": "Portefeuille",
  },

  en: {
    "common.loading": "Loading…",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.send": "Send",
    "common.close": "Close",
    "common.delete": "Delete",
    "common.subscribe": "Subscribe",
    "common.subscribed": "Subscribed",
    "common.unlock": "Unlock",
    "common.locked": "Locked",
    "common.unlocked": "Unlocked",
    "common.photo": "Photo",
    "common.video": "Video",
    "common.publish": "Publish",
    "common.translate": "Translate",
    "common.showOriginal": "Show original",
    "common.pleaseWait": "Please wait…",

    "nav.home": "Home",
    "nav.friends": "Friends",
    "nav.send": "Send",
    "nav.wallet": "Wallet",
    "nav.profile": "Profile",
    "nav.wall": "My wall",

    "auth.login": "Log in",
    "auth.register": "Sign up",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.username": "Username",
    "auth.signIn": "Log in",
    "auth.createAccount": "Create my account",
    "auth.age": "I confirm I am 18 or older and accept the Terms of Service and content rules.",
    "auth.idUpload": "ID document (age verification)",
    "auth.idUploadHint": "Required for registration. Used for 18+ moderation.",
    "auth.idAdd": "Add my ID document",
    "auth.idAdded": "ID document added",
    "auth.forgot": "Forgot password?",
    "auth.reset": "Reset password",
    "auth.resetHint": "Enter your email to receive a reset link.",
    "auth.newPassword": "New password",
    "auth.backToLogin": "Back to login",
    "auth.welcome": "Welcome to MIHOD PAY!",
    "auth.tagline": "Share private photos. At your price.",
    "auth.subtitle": "Send a locked photo to a friend. It unlocks only after payment — and you keep 80% of every sale.",
    "auth.ageError": "You must confirm you are 18 or older.",
    "auth.idError": "Please add an ID document.",
    "auth.onlyAdults": "18+ only.",

    "home.yourBalance": "Your balance",
    "home.recharge": "Top up",
    "home.received": "Received photos",
    "home.noPhotos": "No photos yet",
    "home.noPhotosHint": "Add friends to receive locked photos.",
    "home.findFriends": "Find friends",
    "home.count": "item(s)",

    "explore.title": "Explore",
    "explore.searchPlaceholder": "Search creators, #hashtags, sounds…",
    "explore.creators": "Creators",
    "explore.hashtags": "Hashtags",
    "explore.sounds": "Sounds",
    "explore.trendingTags": "Trending hashtags",
    "explore.trendingSounds": "Trending sounds",
    "explore.suggested": "Suggested creators",
    "explore.noResults": "No results",

    "profile.title": "Profile",
    "profile.balance": "Balance",
    "profile.earnings": "Earnings",
    "profile.sold": "Sold",
    "profile.private": "Private account",
    "profile.privateDesc": "Only your friends can send you photos.",
    "profile.creatorSub": "Creator subscription",
    "profile.creatorSubDesc": "Monthly access to all your photos (Stripe plans).",
    "profile.locked": "Locked",
    "profile.subGate": "Unlocked from",
    "profile.subscribers": "subscribers — you have",
    "profile.language": "Language",
    "profile.languageDesc": "Choose the interface language.",
    "profile.avatarChange": "Change photo",
    "profile.publications": "Publications",
    "profile.photosPublished": "Photos",
    "profile.videosPublished": "Videos",
    "profile.myWall": "View my public wall",
    "profile.subscribersCount": "Subscribers",
    "profile.mySubs": "My subscriptions",
    "profile.yourSubscribers": "Your subscribers",
    "profile.blocked": "Blocked users",
    "profile.noBlocked": "No blocked users.",
    "profile.unblock": "Unblock",
    "profile.tos": "Terms of Service",
    "profile.safety": "Safety & moderation",
    "profile.logout": "Log out",
    "profile.kycPending": "Identity verification pending",
    "profile.kycApproved": "Identity verified",
    "account.title": "Edit account",
    "account.desc": "Update your username, email or password.",
    "account.edit": "Edit",
    "account.info": "Information",
    "account.currentPassword": "Current password",
    "account.saveInfo": "Save",
    "account.changePassword": "Change password",
    "account.infoSaved": "Account updated",
    "account.passwordChanged": "Password changed",

    "send.title": "Send media",
    "send.recipient": "Recipient",
    "send.noFriends": "No friends available",
    "send.add": "Add",
    "send.media": "Media",
    "send.choosePhoto": "Choose a photo or video",
    "send.formats": "JPG, PNG, MP4 • photo max 8 MB",
    "send.changeMedia": "Change media",
    "send.willLock": "Will be locked at",
    "send.price": "Unlock price",
    "send.youEarn": "You will earn",
    "send.caption": "Caption (optional)",
    "send.captionPlaceholder": "Add a message…",
    "send.submit": "Send locked media",
    "send.sending": "Sending…",
    "send.noMax": "No price limit — minimum €1",

    "conv.start": "Start the conversation or send a locked photo.",
    "conv.write": "Write a message…",
    "conv.requestPhoto": "Request a photo",
    "conv.sendPhoto": "Send a photo",
    "conv.translating": "Translating…",

    "wall.title": "My creator wall",
    "wall.subtitle": "Publish paid photos and videos visible to everyone.",
    "wall.publish": "New post",
    "wall.publishTo": "Publish to my wall",
    "wall.empty": "No posts yet.",
    "wall.emptyHint": "Add your first paid photo or video.",
    "wall.visitVitrine": "View my showcase page",
    "wall.published": "Post added to your wall",
    "wall.creatorPage": "Creator page",
    "wall.posts": "posts",
    "wall.subscribeToUnlock": "Subscribe to unlock everything",
    "wall.notFound": "Creator not found",
    "wall.by": "Posts by",

    "wallet.title": "Wallet",
  },

  ru: {
    "common.loading": "Загрузка…",
    "common.cancel": "Отмена",
    "common.save": "Сохранить",
    "common.send": "Отправить",
    "common.close": "Закрыть",
    "common.delete": "Удалить",
    "common.subscribe": "Подписаться",
    "common.subscribed": "Подписан",
    "common.unlock": "Разблокировать",
    "common.locked": "Заблокировано",
    "common.unlocked": "Разблокировано",
    "common.photo": "Фото",
    "common.video": "Видео",
    "common.publish": "Опубликовать",
    "common.translate": "Перевести",
    "common.showOriginal": "Показать оригинал",
    "common.pleaseWait": "Пожалуйста, подождите…",

    "nav.home": "Главная",
    "nav.friends": "Друзья",
    "nav.send": "Отправить",
    "nav.wallet": "Кошелёк",
    "nav.profile": "Профиль",
    "nav.wall": "Моя стена",

    "auth.login": "Вход",
    "auth.register": "Регистрация",
    "auth.email": "Эл. почта",
    "auth.password": "Пароль",
    "auth.username": "Имя пользователя",
    "auth.signIn": "Войти",
    "auth.createAccount": "Создать аккаунт",
    "auth.age": "Я подтверждаю, что мне 18 лет или больше, и принимаю Условия использования и правила контента.",
    "auth.idUpload": "Документ (проверка возраста)",
    "auth.idUploadHint": "Обязательно для регистрации. Используется для модерации 18+.",
    "auth.idAdd": "Добавить документ",
    "auth.idAdded": "Документ добавлен",
    "auth.forgot": "Забыли пароль?",
    "auth.reset": "Сбросить пароль",
    "auth.resetHint": "Введите эл. почту, чтобы получить ссылку для сброса.",
    "auth.newPassword": "Новый пароль",
    "auth.backToLogin": "Назад ко входу",
    "auth.welcome": "Добро пожаловать в MIHOD PAY!",
    "auth.tagline": "Делитесь личными фото. По вашей цене.",
    "auth.subtitle": "Отправьте заблокированное фото другу. Оно откроется только после оплаты — вы получаете 80% с каждой продажи.",
    "auth.ageError": "Вы должны подтвердить, что вам 18 лет или больше.",
    "auth.idError": "Пожалуйста, добавьте документ.",
    "auth.onlyAdults": "Только 18+.",

    "home.yourBalance": "Ваш баланс",
    "home.recharge": "Пополнить",
    "home.received": "Полученные фото",
    "home.noPhotos": "Пока нет фото",
    "home.noPhotosHint": "Добавьте друзей, чтобы получать заблокированные фото.",
    "home.findFriends": "Найти друзей",
    "home.count": "элемент(ов)",

    "profile.title": "Профиль",
    "profile.balance": "Баланс",
    "profile.earnings": "Доход",
    "profile.sold": "Продано",
    "profile.private": "Приватный аккаунт",
    "profile.privateDesc": "Только друзья могут отправлять вам фото.",
    "profile.creatorSub": "Подписка на автора",
    "profile.creatorSubDesc": "Месячный доступ ко всем вашим фото (Stripe).",
    "profile.locked": "Заблокировано",
    "profile.subGate": "Открывается от",
    "profile.subscribers": "подписчиков — у вас",
    "profile.language": "Язык",
    "profile.languageDesc": "Выберите язык интерфейса.",
    "profile.avatarChange": "Изменить фото",
    "profile.publications": "Публикации",
    "profile.photosPublished": "Фото",
    "profile.videosPublished": "Видео",
    "profile.myWall": "Открыть мою стену",
    "profile.subscribersCount": "Подписчики",
    "profile.mySubs": "Мои подписки",
    "profile.yourSubscribers": "Ваши подписчики",
    "profile.blocked": "Заблокированные пользователи",
    "profile.noBlocked": "Нет заблокированных.",
    "profile.unblock": "Разблокировать",
    "profile.tos": "Условия использования",
    "profile.safety": "Безопасность и модерация",
    "profile.logout": "Выйти",
    "profile.kycPending": "Проверка личности ожидается",
    "profile.kycApproved": "Личность подтверждена",

    "send.title": "Отправить медиа",
    "send.recipient": "Получатель",
    "send.noFriends": "Нет доступных друзей",
    "send.add": "Добавить",
    "send.media": "Медиа",
    "send.choosePhoto": "Выберите фото или видео",
    "send.formats": "JPG, PNG, MP4 • фото до 8 МБ",
    "send.changeMedia": "Изменить медиа",
    "send.willLock": "Будет заблокировано за",
    "send.price": "Цена разблокировки",
    "send.youEarn": "Вы получите",
    "send.caption": "Подпись (необязательно)",
    "send.captionPlaceholder": "Добавьте сообщение…",
    "send.submit": "Отправить заблокированное медиа",
    "send.sending": "Отправка…",
    "send.noMax": "Без ограничения цены — минимум 1 €",

    "conv.start": "Начните разговор или отправьте заблокированное фото.",
    "conv.write": "Написать сообщение…",
    "conv.requestPhoto": "Запросить фото",
    "conv.sendPhoto": "Отправить фото",
    "conv.translating": "Перевод…",

    "wall.title": "Моя стена автора",
    "wall.subtitle": "Публикуйте платные фото и видео, видимые всем.",
    "wall.publish": "Новая публикация",
    "wall.publishTo": "Опубликовать на стене",
    "wall.empty": "Пока нет публикаций.",
    "wall.emptyHint": "Добавьте первое платное фото или видео.",
    "wall.visitVitrine": "Моя витрина",
    "wall.published": "Публикация добавлена на стену",
    "wall.creatorPage": "Страница автора",
    "wall.posts": "публикаций",
    "wall.subscribeToUnlock": "Подпишитесь, чтобы всё открыть",
    "wall.notFound": "Автор не найден",
    "wall.by": "Публикации от",

    "wallet.title": "Кошелёк",
  },

  es: {
    "common.loading": "Cargando…",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.send": "Enviar",
    "common.close": "Cerrar",
    "common.delete": "Eliminar",
    "common.subscribe": "Suscribirse",
    "common.subscribed": "Suscrito",
    "common.unlock": "Desbloquear",
    "common.locked": "Bloqueada",
    "common.unlocked": "Desbloqueada",
    "common.photo": "Foto",
    "common.video": "Vídeo",
    "common.publish": "Publicar",
    "common.translate": "Traducir",
    "common.showOriginal": "Ver original",
    "common.pleaseWait": "Espere por favor…",

    "nav.home": "Inicio",
    "nav.friends": "Amigos",
    "nav.send": "Enviar",
    "nav.wallet": "Cartera",
    "nav.profile": "Perfil",
    "nav.wall": "Mi muro",

    "auth.login": "Iniciar sesión",
    "auth.register": "Registro",
    "auth.email": "Correo",
    "auth.password": "Contraseña",
    "auth.username": "Usuario",
    "auth.signIn": "Iniciar sesión",
    "auth.createAccount": "Crear mi cuenta",
    "auth.age": "Confirmo que tengo 18 años o más y acepto las Condiciones de uso y las reglas de contenido.",
    "auth.idUpload": "Documento de identidad (verificación de edad)",
    "auth.idUploadHint": "Obligatorio para el registro. Usado para moderación 18+.",
    "auth.idAdd": "Añadir mi documento",
    "auth.idAdded": "Documento añadido",
    "auth.forgot": "¿Olvidó su contraseña?",
    "auth.reset": "Restablecer contraseña",
    "auth.resetHint": "Introduzca su correo para recibir un enlace de restablecimiento.",
    "auth.newPassword": "Nueva contraseña",
    "auth.backToLogin": "Volver al inicio de sesión",
    "auth.welcome": "¡Bienvenido a MIHOD PAY!",
    "auth.tagline": "Comparte fotos privadas. A tu precio.",
    "auth.subtitle": "Envía una foto bloqueada a un amigo. Se desbloquea solo tras el pago — y te quedas con el 80% de cada venta.",
    "auth.ageError": "Debe confirmar que tiene 18 años o más.",
    "auth.idError": "Añada un documento de identidad.",
    "auth.onlyAdults": "Solo para mayores de 18 años.",

    "home.yourBalance": "Tu saldo",
    "home.recharge": "Recargar",
    "home.received": "Fotos recibidas",
    "home.noPhotos": "Aún no hay fotos",
    "home.noPhotosHint": "Añade amigos para recibir fotos bloqueadas.",
    "home.findFriends": "Buscar amigos",
    "home.count": "elemento(s)",

    "profile.title": "Perfil",
    "profile.balance": "Saldo",
    "profile.earnings": "Ingresos",
    "profile.sold": "Vendidas",
    "profile.private": "Cuenta privada",
    "profile.privateDesc": "Solo tus amigos pueden enviarte fotos.",
    "profile.creatorSub": "Suscripción de creador",
    "profile.creatorSubDesc": "Acceso mensual a todas tus fotos (planes Stripe).",
    "profile.locked": "Bloqueado",
    "profile.subGate": "Se desbloquea desde",
    "profile.subscribers": "suscriptores — tienes",
    "profile.language": "Idioma",
    "profile.languageDesc": "Elige el idioma de la interfaz.",
    "profile.avatarChange": "Cambiar foto",
    "profile.publications": "Publicaciones",
    "profile.photosPublished": "Fotos",
    "profile.videosPublished": "Vídeos",
    "profile.myWall": "Ver mi muro público",
    "profile.subscribersCount": "Suscriptores",
    "profile.mySubs": "Mis suscripciones",
    "profile.yourSubscribers": "Tus suscriptores",
    "profile.blocked": "Usuarios bloqueados",
    "profile.noBlocked": "Ningún usuario bloqueado.",
    "profile.unblock": "Desbloquear",
    "profile.tos": "Condiciones de uso",
    "profile.safety": "Seguridad y moderación",
    "profile.logout": "Cerrar sesión",
    "profile.kycPending": "Verificación de identidad pendiente",
    "profile.kycApproved": "Identidad verificada",

    "send.title": "Enviar contenido",
    "send.recipient": "Destinatario",
    "send.noFriends": "No hay amigos disponibles",
    "send.add": "Añadir",
    "send.media": "Contenido",
    "send.choosePhoto": "Elige una foto o vídeo",
    "send.formats": "JPG, PNG, MP4 • foto máx 8 MB",
    "send.changeMedia": "Cambiar contenido",
    "send.willLock": "Se bloqueará a",
    "send.price": "Precio de desbloqueo",
    "send.youEarn": "Ganarás",
    "send.caption": "Descripción (opcional)",
    "send.captionPlaceholder": "Añade un mensaje…",
    "send.submit": "Enviar contenido bloqueado",
    "send.sending": "Enviando…",
    "send.noMax": "Sin límite de precio — mínimo 1 €",

    "conv.start": "Inicia la conversación o envía una foto bloqueada.",
    "conv.write": "Escribe un mensaje…",
    "conv.requestPhoto": "Pedir una foto",
    "conv.sendPhoto": "Enviar una foto",
    "conv.translating": "Traduciendo…",

    "wall.title": "Mi muro de creador",
    "wall.subtitle": "Publica fotos y vídeos de pago visibles para todos.",
    "wall.publish": "Nueva publicación",
    "wall.publishTo": "Publicar en mi muro",
    "wall.empty": "Aún no hay publicaciones.",
    "wall.emptyHint": "Añade tu primera foto o vídeo de pago.",
    "wall.visitVitrine": "Ver mi página de escaparate",
    "wall.published": "Publicación añadida a tu muro",
    "wall.creatorPage": "Página de creador",
    "wall.posts": "publicaciones",
    "wall.subscribeToUnlock": "Suscríbete para desbloquear todo",
    "wall.notFound": "Creador no encontrado",
    "wall.by": "Publicaciones de",

    "wallet.title": "Cartera",
  },

  pt: {
    "common.loading": "A carregar…",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.send": "Enviar",
    "common.close": "Fechar",
    "common.delete": "Eliminar",
    "common.subscribe": "Subscrever",
    "common.subscribed": "Subscrito",
    "common.unlock": "Desbloquear",
    "common.locked": "Bloqueada",
    "common.unlocked": "Desbloqueada",
    "common.photo": "Foto",
    "common.video": "Vídeo",
    "common.publish": "Publicar",
    "common.translate": "Traduzir",
    "common.showOriginal": "Ver original",
    "common.pleaseWait": "Aguarde…",

    "nav.home": "Início",
    "nav.friends": "Amigos",
    "nav.send": "Enviar",
    "nav.wallet": "Carteira",
    "nav.profile": "Perfil",
    "nav.wall": "O meu mural",

    "auth.login": "Entrar",
    "auth.register": "Registo",
    "auth.email": "Email",
    "auth.password": "Palavra-passe",
    "auth.username": "Utilizador",
    "auth.signIn": "Entrar",
    "auth.createAccount": "Criar a minha conta",
    "auth.age": "Confirmo que tenho 18 anos ou mais e aceito os Termos de utilização e as regras de conteúdo.",
    "auth.idUpload": "Documento de identidade (verificação de idade)",
    "auth.idUploadHint": "Obrigatório para o registo. Usado para moderação 18+.",
    "auth.idAdd": "Adicionar o meu documento",
    "auth.idAdded": "Documento adicionado",
    "auth.forgot": "Esqueceu-se da palavra-passe?",
    "auth.reset": "Repor palavra-passe",
    "auth.resetHint": "Introduza o seu email para receber um link de reposição.",
    "auth.newPassword": "Nova palavra-passe",
    "auth.backToLogin": "Voltar ao início de sessão",
    "auth.welcome": "Bem-vindo ao MIHOD PAY!",
    "auth.tagline": "Partilhe fotos privadas. Ao seu preço.",
    "auth.subtitle": "Envie uma foto bloqueada a um amigo. Só desbloqueia após pagamento — e fica com 80% de cada venda.",
    "auth.ageError": "Deve confirmar que tem 18 anos ou mais.",
    "auth.idError": "Adicione um documento de identidade.",
    "auth.onlyAdults": "Apenas maiores de 18 anos.",

    "home.yourBalance": "O seu saldo",
    "home.recharge": "Carregar",
    "home.received": "Fotos recebidas",
    "home.noPhotos": "Ainda sem fotos",
    "home.noPhotosHint": "Adicione amigos para receber fotos bloqueadas.",
    "home.findFriends": "Encontrar amigos",
    "home.count": "item(ns)",

    "profile.title": "Perfil",
    "profile.balance": "Saldo",
    "profile.earnings": "Rendimentos",
    "profile.sold": "Vendidas",
    "profile.private": "Conta privada",
    "profile.privateDesc": "Apenas os seus amigos podem enviar-lhe fotos.",
    "profile.creatorSub": "Subscrição de criador",
    "profile.creatorSubDesc": "Acesso mensal a todas as suas fotos (planos Stripe).",
    "profile.locked": "Bloqueado",
    "profile.subGate": "Desbloqueado a partir de",
    "profile.subscribers": "subscritores — tem",
    "profile.language": "Idioma",
    "profile.languageDesc": "Escolha o idioma da interface.",
    "profile.avatarChange": "Mudar foto",
    "profile.publications": "Publicações",
    "profile.photosPublished": "Fotos",
    "profile.videosPublished": "Vídeos",
    "profile.myWall": "Ver o meu mural público",
    "profile.subscribersCount": "Subscritores",
    "profile.mySubs": "As minhas subscrições",
    "profile.yourSubscribers": "Os seus subscritores",
    "profile.blocked": "Utilizadores bloqueados",
    "profile.noBlocked": "Nenhum utilizador bloqueado.",
    "profile.unblock": "Desbloquear",
    "profile.tos": "Termos de utilização",
    "profile.safety": "Segurança e moderação",
    "profile.logout": "Terminar sessão",
    "profile.kycPending": "Verificação de identidade pendente",
    "profile.kycApproved": "Identidade verificada",

    "send.title": "Enviar conteúdo",
    "send.recipient": "Destinatário",
    "send.noFriends": "Nenhum amigo disponível",
    "send.add": "Adicionar",
    "send.media": "Conteúdo",
    "send.choosePhoto": "Escolha uma foto ou vídeo",
    "send.formats": "JPG, PNG, MP4 • foto máx 8 MB",
    "send.changeMedia": "Mudar conteúdo",
    "send.willLock": "Será bloqueado a",
    "send.price": "Preço de desbloqueio",
    "send.youEarn": "Vai receber",
    "send.caption": "Legenda (opcional)",
    "send.captionPlaceholder": "Adicione uma mensagem…",
    "send.submit": "Enviar conteúdo bloqueado",
    "send.sending": "A enviar…",
    "send.noMax": "Sem limite de preço — mínimo 1 €",

    "conv.start": "Inicie a conversa ou envie uma foto bloqueada.",
    "conv.write": "Escreva uma mensagem…",
    "conv.requestPhoto": "Pedir uma foto",
    "conv.sendPhoto": "Enviar uma foto",
    "conv.translating": "A traduzir…",

    "wall.title": "O meu mural de criador",
    "wall.subtitle": "Publique fotos e vídeos pagos visíveis para todos.",
    "wall.publish": "Nova publicação",
    "wall.publishTo": "Publicar no meu mural",
    "wall.empty": "Ainda sem publicações.",
    "wall.emptyHint": "Adicione a sua primeira foto ou vídeo pago.",
    "wall.visitVitrine": "Ver a minha página de montra",
    "wall.published": "Publicação adicionada ao seu mural",
    "wall.creatorPage": "Página de criador",
    "wall.posts": "publicações",
    "wall.subscribeToUnlock": "Subscreva para desbloquear tudo",
    "wall.notFound": "Criador não encontrado",
    "wall.by": "Publicações de",

    "wallet.title": "Carteira",
  },

  uk: {
    "common.loading": "Завантаження…",
    "common.cancel": "Скасувати",
    "common.save": "Зберегти",
    "common.send": "Надіслати",
    "common.close": "Закрити",
    "common.delete": "Видалити",
    "common.subscribe": "Підписатися",
    "common.subscribed": "Підписано",
    "common.unlock": "Розблокувати",
    "common.locked": "Заблоковано",
    "common.unlocked": "Розблоковано",
    "common.photo": "Фото",
    "common.video": "Відео",
    "common.publish": "Опублікувати",
    "common.translate": "Перекласти",
    "common.showOriginal": "Показати оригінал",
    "common.pleaseWait": "Зачекайте…",

    "nav.home": "Головна",
    "nav.friends": "Друзі",
    "nav.send": "Надіслати",
    "nav.wallet": "Гаманець",
    "nav.profile": "Профіль",
    "nav.wall": "Моя стіна",

    "auth.login": "Вхід",
    "auth.register": "Реєстрація",
    "auth.email": "Ел. пошта",
    "auth.password": "Пароль",
    "auth.username": "Ім'я користувача",
    "auth.signIn": "Увійти",
    "auth.createAccount": "Створити акаунт",
    "auth.age": "Я підтверджую, що мені 18 років або більше, і приймаю Умови використання та правила контенту.",
    "auth.idUpload": "Документ (перевірка віку)",
    "auth.idUploadHint": "Обов'язково для реєстрації. Використовується для модерації 18+.",
    "auth.idAdd": "Додати документ",
    "auth.idAdded": "Документ додано",
    "auth.forgot": "Забули пароль?",
    "auth.reset": "Скинути пароль",
    "auth.resetHint": "Введіть ел. пошту, щоб отримати посилання для скидання.",
    "auth.newPassword": "Новий пароль",
    "auth.backToLogin": "Назад до входу",
    "auth.welcome": "Ласкаво просимо до MIHOD PAY!",
    "auth.tagline": "Діліться приватними фото. За вашою ціною.",
    "auth.subtitle": "Надішліть заблоковане фото другові. Воно відкриється лише після оплати — ви отримуєте 80% з кожного продажу.",
    "auth.ageError": "Ви маєте підтвердити, що вам 18 років або більше.",
    "auth.idError": "Будь ласка, додайте документ.",
    "auth.onlyAdults": "Лише 18+.",

    "home.yourBalance": "Ваш баланс",
    "home.recharge": "Поповнити",
    "home.received": "Отримані фото",
    "home.noPhotos": "Поки немає фото",
    "home.noPhotosHint": "Додайте друзів, щоб отримувати заблоковані фото.",
    "home.findFriends": "Знайти друзів",
    "home.count": "елемент(ів)",

    "profile.title": "Профіль",
    "profile.balance": "Баланс",
    "profile.earnings": "Дохід",
    "profile.sold": "Продано",
    "profile.private": "Приватний акаунт",
    "profile.privateDesc": "Лише друзі можуть надсилати вам фото.",
    "profile.creatorSub": "Підписка на автора",
    "profile.creatorSubDesc": "Місячний доступ до всіх ваших фото (плани Stripe).",
    "profile.locked": "Заблоковано",
    "profile.subGate": "Відкривається від",
    "profile.subscribers": "підписників — у вас",
    "profile.language": "Мова",
    "profile.languageDesc": "Оберіть мову інтерфейсу.",
    "profile.avatarChange": "Змінити фото",
    "profile.publications": "Публікації",
    "profile.photosPublished": "Фото",
    "profile.videosPublished": "Відео",
    "profile.myWall": "Переглянути мою стіну",
    "profile.subscribersCount": "Підписники",
    "profile.mySubs": "Мої підписки",
    "profile.yourSubscribers": "Ваші підписники",
    "profile.blocked": "Заблоковані користувачі",
    "profile.noBlocked": "Немає заблокованих.",
    "profile.unblock": "Розблокувати",
    "profile.tos": "Умови використання",
    "profile.safety": "Безпека та модерація",
    "profile.logout": "Вийти",
    "profile.kycPending": "Перевірка особи очікується",
    "profile.kycApproved": "Особу підтверджено",

    "send.title": "Надіслати медіа",
    "send.recipient": "Отримувач",
    "send.noFriends": "Немає доступних друзів",
    "send.add": "Додати",
    "send.media": "Медіа",
    "send.choosePhoto": "Оберіть фото або відео",
    "send.formats": "JPG, PNG, MP4 • фото до 8 МБ",
    "send.changeMedia": "Змінити медіа",
    "send.willLock": "Буде заблоковано за",
    "send.price": "Ціна розблокування",
    "send.youEarn": "Ви отримаєте",
    "send.caption": "Підпис (необов'язково)",
    "send.captionPlaceholder": "Додайте повідомлення…",
    "send.submit": "Надіслати заблоковане медіа",
    "send.sending": "Надсилання…",
    "send.noMax": "Без обмеження ціни — мінімум 1 €",

    "conv.start": "Почніть розмову або надішліть заблоковане фото.",
    "conv.write": "Написати повідомлення…",
    "conv.requestPhoto": "Запросити фото",
    "conv.sendPhoto": "Надіслати фото",
    "conv.translating": "Переклад…",

    "wall.title": "Моя стіна автора",
    "wall.subtitle": "Публікуйте платні фото та відео, видимі всім.",
    "wall.publish": "Нова публікація",
    "wall.publishTo": "Опублікувати на стіні",
    "wall.empty": "Поки немає публікацій.",
    "wall.emptyHint": "Додайте перше платне фото або відео.",
    "wall.visitVitrine": "Моя вітрина",
    "wall.published": "Публікацію додано на стіну",
    "wall.creatorPage": "Сторінка автора",
    "wall.posts": "публікацій",
    "wall.subscribeToUnlock": "Підпишіться, щоб усе відкрити",
    "wall.notFound": "Автора не знайдено",
    "wall.by": "Публікації від",

    "wallet.title": "Гаманець",
  },

  pl: {
    "common.loading": "Ładowanie…",
    "common.cancel": "Anuluj",
    "common.save": "Zapisz",
    "common.send": "Wyślij",
    "common.close": "Zamknij",
    "common.delete": "Usuń",
    "common.subscribe": "Subskrybuj",
    "common.subscribed": "Subskrybowano",
    "common.unlock": "Odblokuj",
    "common.locked": "Zablokowane",
    "common.unlocked": "Odblokowane",
    "common.photo": "Zdjęcie",
    "common.video": "Wideo",
    "common.publish": "Opublikuj",
    "common.translate": "Przetłumacz",
    "common.showOriginal": "Pokaż oryginał",
    "common.pleaseWait": "Proszę czekać…",

    "nav.home": "Główna",
    "nav.friends": "Znajomi",
    "nav.send": "Wyślij",
    "nav.wallet": "Portfel",
    "nav.profile": "Profil",
    "nav.wall": "Moja ściana",

    "auth.login": "Logowanie",
    "auth.register": "Rejestracja",
    "auth.email": "Email",
    "auth.password": "Hasło",
    "auth.username": "Nazwa użytkownika",
    "auth.signIn": "Zaloguj się",
    "auth.createAccount": "Utwórz konto",
    "auth.age": "Potwierdzam, że mam 18 lat lub więcej i akceptuję Regulamin oraz zasady dotyczące treści.",
    "auth.idUpload": "Dokument tożsamości (weryfikacja wieku)",
    "auth.idUploadHint": "Wymagane do rejestracji. Używane do moderacji 18+.",
    "auth.idAdd": "Dodaj dokument",
    "auth.idAdded": "Dokument dodany",
    "auth.forgot": "Nie pamiętasz hasła?",
    "auth.reset": "Zresetuj hasło",
    "auth.resetHint": "Wprowadź email, aby otrzymać link do resetowania.",
    "auth.newPassword": "Nowe hasło",
    "auth.backToLogin": "Powrót do logowania",
    "auth.welcome": "Witaj w MIHOD PAY!",
    "auth.tagline": "Udostępniaj prywatne zdjęcia. W swojej cenie.",
    "auth.subtitle": "Wyślij zablokowane zdjęcie znajomemu. Odblokuje się dopiero po opłacie — zatrzymujesz 80% z każdej sprzedaży.",
    "auth.ageError": "Musisz potwierdzić, że masz 18 lat lub więcej.",
    "auth.idError": "Dodaj dokument tożsamości.",
    "auth.onlyAdults": "Tylko 18+.",

    "home.yourBalance": "Twoje saldo",
    "home.recharge": "Doładuj",
    "home.received": "Otrzymane zdjęcia",
    "home.noPhotos": "Brak zdjęć",
    "home.noPhotosHint": "Dodaj znajomych, aby otrzymywać zablokowane zdjęcia.",
    "home.findFriends": "Znajdź znajomych",
    "home.count": "element(ów)",

    "profile.title": "Profil",
    "profile.balance": "Saldo",
    "profile.earnings": "Zarobki",
    "profile.sold": "Sprzedane",
    "profile.private": "Konto prywatne",
    "profile.privateDesc": "Tylko znajomi mogą wysyłać Ci zdjęcia.",
    "profile.creatorSub": "Subskrypcja twórcy",
    "profile.creatorSubDesc": "Miesięczny dostęp do wszystkich Twoich zdjęć (Stripe).",
    "profile.locked": "Zablokowane",
    "profile.subGate": "Odblokowane od",
    "profile.subscribers": "subskrybentów — masz",
    "profile.language": "Język",
    "profile.languageDesc": "Wybierz język interfejsu.",
    "profile.avatarChange": "Zmień zdjęcie",
    "profile.publications": "Publikacje",
    "profile.photosPublished": "Zdjęcia",
    "profile.videosPublished": "Wideo",
    "profile.myWall": "Zobacz moją ścianę",
    "profile.subscribersCount": "Subskrybenci",
    "profile.mySubs": "Moje subskrypcje",
    "profile.yourSubscribers": "Twoi subskrybenci",
    "profile.blocked": "Zablokowani użytkownicy",
    "profile.noBlocked": "Brak zablokowanych.",
    "profile.unblock": "Odblokuj",
    "profile.tos": "Regulamin",
    "profile.safety": "Bezpieczeństwo i moderacja",
    "profile.logout": "Wyloguj się",
    "profile.kycPending": "Weryfikacja tożsamości w toku",
    "profile.kycApproved": "Tożsamość zweryfikowana",

    "send.title": "Wyślij media",
    "send.recipient": "Odbiorca",
    "send.noFriends": "Brak dostępnych znajomych",
    "send.add": "Dodaj",
    "send.media": "Media",
    "send.choosePhoto": "Wybierz zdjęcie lub wideo",
    "send.formats": "JPG, PNG, MP4 • zdjęcie maks 8 MB",
    "send.changeMedia": "Zmień media",
    "send.willLock": "Zostanie zablokowane za",
    "send.price": "Cena odblokowania",
    "send.youEarn": "Zarobisz",
    "send.caption": "Podpis (opcjonalnie)",
    "send.captionPlaceholder": "Dodaj wiadomość…",
    "send.submit": "Wyślij zablokowane media",
    "send.sending": "Wysyłanie…",
    "send.noMax": "Bez limitu ceny — minimum 1 €",

    "conv.start": "Rozpocznij rozmowę lub wyślij zablokowane zdjęcie.",
    "conv.write": "Napisz wiadomość…",
    "conv.requestPhoto": "Poproś o zdjęcie",
    "conv.sendPhoto": "Wyślij zdjęcie",
    "conv.translating": "Tłumaczenie…",

    "wall.title": "Moja ściana twórcy",
    "wall.subtitle": "Publikuj płatne zdjęcia i wideo widoczne dla wszystkich.",
    "wall.publish": "Nowy post",
    "wall.publishTo": "Opublikuj na ścianie",
    "wall.empty": "Brak postów.",
    "wall.emptyHint": "Dodaj swoje pierwsze płatne zdjęcie lub wideo.",
    "wall.visitVitrine": "Zobacz moją witrynę",
    "wall.published": "Post dodany do ściany",
    "wall.creatorPage": "Strona twórcy",
    "wall.posts": "postów",
    "wall.subscribeToUnlock": "Subskrybuj, aby odblokować wszystko",
    "wall.notFound": "Nie znaleziono twórcy",
    "wall.by": "Posty od",

    "wallet.title": "Portfel",
  },

  ja: {
    "common.loading": "読み込み中…",
    "common.cancel": "キャンセル",
    "common.save": "保存",
    "common.send": "送信",
    "common.close": "閉じる",
    "common.delete": "削除",
    "common.subscribe": "登録する",
    "common.subscribed": "登録済み",
    "common.unlock": "ロック解除",
    "common.locked": "ロック中",
    "common.unlocked": "解除済み",
    "common.photo": "写真",
    "common.video": "動画",
    "common.publish": "公開",
    "common.translate": "翻訳",
    "common.showOriginal": "原文を表示",
    "common.pleaseWait": "お待ちください…",

    "nav.home": "ホーム",
    "nav.friends": "友達",
    "nav.send": "送信",
    "nav.wallet": "ウォレット",
    "nav.profile": "プロフィール",
    "nav.wall": "マイウォール",

    "auth.login": "ログイン",
    "auth.register": "登録",
    "auth.email": "メール",
    "auth.password": "パスワード",
    "auth.username": "ユーザー名",
    "auth.signIn": "ログイン",
    "auth.createAccount": "アカウントを作成",
    "auth.age": "18歳以上であることを確認し、利用規約とコンテンツルールに同意します。",
    "auth.idUpload": "身分証明書（年齢確認）",
    "auth.idUploadHint": "登録に必須です。18+のモデレーションに使用されます。",
    "auth.idAdd": "身分証明書を追加",
    "auth.idAdded": "身分証明書を追加しました",
    "auth.forgot": "パスワードをお忘れですか？",
    "auth.reset": "パスワードをリセット",
    "auth.resetHint": "リセットリンクを受け取るにはメールを入力してください。",
    "auth.newPassword": "新しいパスワード",
    "auth.backToLogin": "ログインに戻る",
    "auth.welcome": "MIHOD PAYへようこそ！",
    "auth.tagline": "プライベートな写真を、あなたの価格で共有。",
    "auth.subtitle": "ロックした写真を友達に送信。支払い後にのみ解除され、売上の80%があなたに。",
    "auth.ageError": "18歳以上であることを確認してください。",
    "auth.idError": "身分証明書を追加してください。",
    "auth.onlyAdults": "18歳以上限定。",

    "home.yourBalance": "残高",
    "home.recharge": "チャージ",
    "home.received": "受信した写真",
    "home.noPhotos": "まだ写真がありません",
    "home.noPhotosHint": "友達を追加してロック写真を受け取りましょう。",
    "home.findFriends": "友達を探す",
    "home.count": "件",

    "profile.title": "プロフィール",
    "profile.balance": "残高",
    "profile.earnings": "収益",
    "profile.sold": "販売済み",
    "profile.private": "非公開アカウント",
    "profile.privateDesc": "友達のみが写真を送れます。",
    "profile.creatorSub": "クリエイター登録",
    "profile.creatorSubDesc": "すべての写真への月額アクセス（Stripeプラン）。",
    "profile.locked": "ロック中",
    "profile.subGate": "解除に必要:",
    "profile.subscribers": "人の登録者 — 現在",
    "profile.language": "言語",
    "profile.languageDesc": "インターフェースの言語を選択。",
    "profile.avatarChange": "写真を変更",
    "profile.publications": "投稿",
    "profile.photosPublished": "写真",
    "profile.videosPublished": "動画",
    "profile.myWall": "公開ウォールを見る",
    "profile.subscribersCount": "登録者",
    "profile.mySubs": "登録中",
    "profile.yourSubscribers": "あなたの登録者",
    "profile.blocked": "ブロック中のユーザー",
    "profile.noBlocked": "ブロックしているユーザーはいません。",
    "profile.unblock": "ブロック解除",
    "profile.tos": "利用規約",
    "profile.safety": "安全とモデレーション",
    "profile.logout": "ログアウト",
    "profile.kycPending": "本人確認の審査中",
    "profile.kycApproved": "本人確認済み",

    "send.title": "メディアを送信",
    "send.recipient": "宛先",
    "send.noFriends": "利用可能な友達がいません",
    "send.add": "追加",
    "send.media": "メディア",
    "send.choosePhoto": "写真または動画を選択",
    "send.formats": "JPG, PNG, MP4 • 写真は最大8MB",
    "send.changeMedia": "メディアを変更",
    "send.willLock": "この価格でロック:",
    "send.price": "解除価格",
    "send.youEarn": "受取額",
    "send.caption": "キャプション（任意）",
    "send.captionPlaceholder": "メッセージを追加…",
    "send.submit": "ロックしたメディアを送信",
    "send.sending": "送信中…",
    "send.noMax": "価格上限なし — 最低1€",

    "conv.start": "会話を始めるか、ロック写真を送信しましょう。",
    "conv.write": "メッセージを入力…",
    "conv.requestPhoto": "写真をリクエスト",
    "conv.sendPhoto": "写真を送信",
    "conv.translating": "翻訳中…",

    "wall.title": "マイクリエイターウォール",
    "wall.subtitle": "全員に見える有料の写真や動画を公開。",
    "wall.publish": "新規投稿",
    "wall.publishTo": "ウォールに公開",
    "wall.empty": "まだ投稿がありません。",
    "wall.emptyHint": "最初の有料写真または動画を追加しましょう。",
    "wall.visitVitrine": "ショーケースページを見る",
    "wall.published": "ウォールに投稿を追加しました",
    "wall.creatorPage": "クリエイターページ",
    "wall.posts": "件の投稿",
    "wall.subscribeToUnlock": "登録してすべて解除",
    "wall.notFound": "クリエイターが見つかりません",
    "wall.by": "投稿者:",

    "wallet.title": "ウォレット",
  },

  zh: {
    "common.loading": "加载中…",
    "common.cancel": "取消",
    "common.save": "保存",
    "common.send": "发送",
    "common.close": "关闭",
    "common.delete": "删除",
    "common.subscribe": "订阅",
    "common.subscribed": "已订阅",
    "common.unlock": "解锁",
    "common.locked": "已锁定",
    "common.unlocked": "已解锁",
    "common.photo": "照片",
    "common.video": "视频",
    "common.publish": "发布",
    "common.translate": "翻译",
    "common.showOriginal": "查看原文",
    "common.pleaseWait": "请稍候…",

    "nav.home": "首页",
    "nav.friends": "好友",
    "nav.send": "发送",
    "nav.wallet": "钱包",
    "nav.profile": "我的",
    "nav.wall": "我的墙",

    "auth.login": "登录",
    "auth.register": "注册",
    "auth.email": "邮箱",
    "auth.password": "密码",
    "auth.username": "用户名",
    "auth.signIn": "登录",
    "auth.createAccount": "创建账号",
    "auth.age": "我确认已年满18岁，并接受使用条款和内容规则。",
    "auth.idUpload": "身份证件（年龄验证）",
    "auth.idUploadHint": "注册必需。用于18+审核。",
    "auth.idAdd": "添加我的证件",
    "auth.idAdded": "证件已添加",
    "auth.forgot": "忘记密码？",
    "auth.reset": "重置密码",
    "auth.resetHint": "输入邮箱以接收重置链接。",
    "auth.newPassword": "新密码",
    "auth.backToLogin": "返回登录",
    "auth.welcome": "欢迎来到 MIHOD PAY！",
    "auth.tagline": "分享私密照片，价格由你决定。",
    "auth.subtitle": "向好友发送锁定照片。付款后才解锁——每笔销售你保留80%。",
    "auth.ageError": "您必须确认已年满18岁。",
    "auth.idError": "请添加身份证件。",
    "auth.onlyAdults": "仅限18岁以上。",

    "home.yourBalance": "您的余额",
    "home.recharge": "充值",
    "home.received": "收到的照片",
    "home.noPhotos": "暂无照片",
    "home.noPhotosHint": "添加好友以接收锁定照片。",
    "home.findFriends": "查找好友",
    "home.count": "项",

    "profile.title": "我的",
    "profile.balance": "余额",
    "profile.earnings": "收入",
    "profile.sold": "已售",
    "profile.private": "私密账号",
    "profile.privateDesc": "只有好友可以给您发送照片。",
    "profile.creatorSub": "创作者订阅",
    "profile.creatorSubDesc": "按月访问您的所有照片（Stripe 套餐）。",
    "profile.locked": "已锁定",
    "profile.subGate": "解锁需要",
    "profile.subscribers": "名订阅者 — 您当前有",
    "profile.language": "语言",
    "profile.languageDesc": "选择界面语言。",
    "profile.avatarChange": "更换头像",
    "profile.publications": "发布内容",
    "profile.photosPublished": "照片",
    "profile.videosPublished": "视频",
    "profile.myWall": "查看我的公开墙",
    "profile.subscribersCount": "订阅者",
    "profile.mySubs": "我的订阅",
    "profile.yourSubscribers": "您的订阅者",
    "profile.blocked": "已屏蔽用户",
    "profile.noBlocked": "没有屏蔽的用户。",
    "profile.unblock": "取消屏蔽",
    "profile.tos": "使用条款",
    "profile.safety": "安全与审核",
    "profile.logout": "退出登录",
    "profile.kycPending": "身份验证审核中",
    "profile.kycApproved": "身份已验证",

    "send.title": "发送内容",
    "send.recipient": "接收者",
    "send.noFriends": "没有可用好友",
    "send.add": "添加",
    "send.media": "内容",
    "send.choosePhoto": "选择照片或视频",
    "send.formats": "JPG、PNG、MP4 • 照片最大8MB",
    "send.changeMedia": "更换内容",
    "send.willLock": "将锁定价格为",
    "send.price": "解锁价格",
    "send.youEarn": "您将获得",
    "send.caption": "说明（可选）",
    "send.captionPlaceholder": "添加留言…",
    "send.submit": "发送锁定内容",
    "send.sending": "发送中…",
    "send.noMax": "无价格上限 — 最低 1 €",

    "conv.start": "开始对话或发送锁定照片。",
    "conv.write": "写一条消息…",
    "conv.requestPhoto": "请求照片",
    "conv.sendPhoto": "发送照片",
    "conv.translating": "翻译中…",

    "wall.title": "我的创作者墙",
    "wall.subtitle": "发布对所有人可见的付费照片和视频。",
    "wall.publish": "新发布",
    "wall.publishTo": "发布到我的墙",
    "wall.empty": "暂无发布。",
    "wall.emptyHint": "添加您的第一个付费照片或视频。",
    "wall.visitVitrine": "查看我的展示页",
    "wall.published": "已添加到您的墙",
    "wall.creatorPage": "创作者页面",
    "wall.posts": "个发布",
    "wall.subscribeToUnlock": "订阅以解锁全部",
    "wall.notFound": "未找到创作者",
    "wall.by": "发布者：",

    "wallet.title": "钱包",
  },

  de: {
    "common.loading": "Wird geladen…",
    "common.cancel": "Abbrechen",
    "common.save": "Speichern",
    "common.send": "Senden",
    "common.close": "Schließen",
    "common.delete": "Löschen",
    "common.subscribe": "Abonnieren",
    "common.subscribed": "Abonniert",
    "common.unlock": "Freischalten",
    "common.locked": "Gesperrt",
    "common.unlocked": "Freigeschaltet",
    "common.photo": "Foto",
    "common.video": "Video",
    "common.publish": "Veröffentlichen",
    "common.translate": "Übersetzen",
    "common.showOriginal": "Original anzeigen",
    "common.pleaseWait": "Bitte warten…",
    "nav.home": "Start",
    "nav.friends": "Freunde",
    "nav.send": "Senden",
    "nav.wallet": "Wallet",
    "nav.profile": "Profil",
    "nav.wall": "Meine Wand",
    "auth.login": "Anmelden",
    "auth.register": "Registrieren",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.username": "Benutzername",
    "auth.signIn": "Einloggen",
    "auth.createAccount": "Konto erstellen",
    "auth.age": "Ich bestätige, dass ich 18 Jahre oder älter bin und akzeptiere die Nutzungsbedingungen und Inhaltsregeln.",
    "auth.idUpload": "Ausweis (Altersprüfung)",
    "auth.idUploadHint": "Pflicht bei der Registrierung. Wird für die 18+ Moderation verwendet.",
    "auth.idAdd": "Ausweis hinzufügen",
    "auth.idAdded": "Ausweis hinzugefügt",
    "auth.forgot": "Passwort vergessen?",
    "auth.reset": "Passwort zurücksetzen",
    "auth.resetHint": "Gib deine E-Mail ein, um einen Link zum Zurücksetzen zu erhalten.",
    "auth.newPassword": "Neues Passwort",
    "auth.backToLogin": "Zurück zur Anmeldung",
    "auth.welcome": "Willkommen bei MIHOD PAY!",
    "auth.tagline": "Teile private Fotos. Zu deinem Preis.",
    "auth.subtitle": "Sende einem Freund ein gesperrtes Foto. Es wird erst nach Zahlung freigeschaltet – und du erhältst 80 % pro Verkauf.",
    "auth.ageError": "Du musst bestätigen, dass du 18 Jahre oder älter bist.",
    "auth.idError": "Bitte füge einen Ausweis hinzu.",
    "auth.onlyAdults": "Nur für Personen ab 18 Jahren.",
    "home.yourBalance": "Dein Guthaben",
    "home.recharge": "Aufladen",
    "home.received": "Erhaltene Fotos",
    "home.noPhotos": "Noch keine Fotos",
    "home.noPhotosHint": "Füge Freunde hinzu, um gesperrte Fotos zu erhalten.",
    "home.findFriends": "Freunde finden",
    "home.count": "Beitrag(e)",
    "explore.title": "Entdecken",
    "explore.searchPlaceholder": "Creator, #Hashtags, Sounds suchen…",
    "explore.creators": "Creator",
    "explore.hashtags": "Hashtags",
    "explore.sounds": "Sounds",
    "explore.trendingTags": "Angesagte Hashtags",
    "explore.trendingSounds": "Angesagte Sounds",
    "explore.suggested": "Vorgeschlagene Creator",
    "explore.noResults": "Keine Ergebnisse",
    "profile.title": "Profil",
    "profile.balance": "Guthaben",
    "profile.earnings": "Einnahmen",
    "profile.sold": "Verkauft",
    "profile.private": "Privates Konto",
    "profile.privateDesc": "Nur deine Freunde können dir Fotos senden.",
    "profile.creatorSub": "Creator-Abo",
    "profile.creatorSubDesc": "Monatlicher Zugang zu all deinen Fotos (Stripe-Tarife).",
    "profile.locked": "Gesperrt",
    "profile.subGate": "Freigeschaltet ab",
    "profile.subscribers": "Abonnenten – du hast",
    "profile.language": "Sprache",
    "profile.languageDesc": "Wähle die Sprache der Oberfläche.",
    "profile.avatarChange": "Foto ändern",
    "profile.publications": "Beiträge",
    "profile.photosPublished": "Fotos",
    "profile.videosPublished": "Videos",
    "profile.myWall": "Meine öffentliche Wand ansehen",
    "profile.subscribersCount": "Abonnenten",
    "profile.mySubs": "Meine Abos",
    "profile.yourSubscribers": "Deine Abonnenten",
    "profile.blocked": "Blockierte Nutzer",
    "profile.noBlocked": "Keine blockierten Nutzer.",
    "profile.unblock": "Entsperren",
    "profile.tos": "Nutzungsbedingungen",
    "profile.safety": "Sicherheit & Moderation",
    "profile.logout": "Abmelden",
    "profile.kycPending": "Identitätsprüfung ausstehend",
    "profile.kycApproved": "Identität bestätigt",
    "account.title": "Konto bearbeiten",
    "account.desc": "Aktualisiere Benutzernamen, E-Mail oder Passwort.",
    "account.edit": "Bearbeiten",
    "account.info": "Informationen",
    "account.currentPassword": "Aktuelles Passwort",
    "account.saveInfo": "Speichern",
    "account.changePassword": "Passwort ändern",
    "account.infoSaved": "Konto aktualisiert",
    "account.passwordChanged": "Passwort geändert",
    "send.title": "Medien senden",
    "send.recipient": "Empfänger",
    "send.noFriends": "Keine Freunde verfügbar",
    "send.add": "Hinzufügen",
    "send.media": "Medien",
    "send.choosePhoto": "Foto oder Video wählen",
    "send.formats": "JPG, PNG, MP4 • Foto max. 8 MB",
    "send.changeMedia": "Medien ändern",
    "send.willLock": "Wird gesperrt bei",
    "send.price": "Freischaltpreis",
    "send.youEarn": "Du erhältst",
    "send.caption": "Bildunterschrift (optional)",
    "send.captionPlaceholder": "Nachricht hinzufügen…",
    "send.submit": "Gesperrte Medien senden",
    "send.sending": "Wird gesendet…",
    "send.noMax": "Keine Preisgrenze – mindestens 1 €",
    "conv.start": "Starte das Gespräch oder sende ein gesperrtes Foto.",
    "conv.write": "Nachricht schreiben…",
    "conv.requestPhoto": "Foto anfragen",
    "conv.sendPhoto": "Foto senden",
    "conv.translating": "Übersetzen…",
    "wall.title": "Meine Creator-Wand",
    "wall.subtitle": "Veröffentliche kostenpflichtige Fotos und Videos, für alle sichtbar.",
    "wall.publish": "Neuer Beitrag",
    "wall.publishTo": "Auf meiner Wand veröffentlichen",
    "wall.empty": "Noch keine Beiträge.",
    "wall.emptyHint": "Füge dein erstes kostenpflichtiges Foto oder Video hinzu.",
    "wall.visitVitrine": "Meine Schaufensterseite ansehen",
    "wall.published": "Beitrag zu deiner Wand hinzugefügt",
    "wall.creatorPage": "Creator-Seite",
    "wall.posts": "Beiträge",
    "wall.subscribeToUnlock": "Abonniere, um alles freizuschalten",
    "wall.notFound": "Creator nicht gefunden",
    "wall.by": "Beiträge von",
    "wallet.title": "Wallet",
  },
  it: {
    "common.loading": "Caricamento…",
    "common.cancel": "Annulla",
    "common.save": "Salva",
    "common.send": "Invia",
    "common.close": "Chiudi",
    "common.delete": "Elimina",
    "common.subscribe": "Iscriviti",
    "common.subscribed": "Iscritto",
    "common.unlock": "Sblocca",
    "common.locked": "Bloccato",
    "common.unlocked": "Sbloccato",
    "common.photo": "Foto",
    "common.video": "Video",
    "common.publish": "Pubblica",
    "common.translate": "Traduci",
    "common.showOriginal": "Mostra originale",
    "common.pleaseWait": "Attendere…",
    "nav.home": "Home",
    "nav.friends": "Amici",
    "nav.send": "Invia",
    "nav.wallet": "Portafoglio",
    "nav.profile": "Profilo",
    "nav.wall": "La mia bacheca",
    "auth.login": "Accedi",
    "auth.register": "Registrati",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.username": "Nome utente",
    "auth.signIn": "Accedi",
    "auth.createAccount": "Crea il mio account",
    "auth.age": "Confermo di avere 18 anni o più e accetto i Termini di utilizzo e le regole sui contenuti.",
    "auth.idUpload": "Documento d'identità (verifica età)",
    "auth.idUploadHint": "Obbligatorio per la registrazione. Usato per la moderazione 18+.",
    "auth.idAdd": "Aggiungi il documento",
    "auth.idAdded": "Documento aggiunto",
    "auth.forgot": "Password dimenticata?",
    "auth.reset": "Reimposta la password",
    "auth.resetHint": "Inserisci la tua email per ricevere un link di reimpostazione.",
    "auth.newPassword": "Nuova password",
    "auth.backToLogin": "Torna all'accesso",
    "auth.welcome": "Benvenuto su MIHOD PAY!",
    "auth.tagline": "Condividi foto private. Al tuo prezzo.",
    "auth.subtitle": "Invia una foto bloccata a un amico. Si sblocca solo dopo il pagamento e tu guadagni l'80% su ogni vendita.",
    "auth.ageError": "Devi confermare di avere 18 anni o più.",
    "auth.idError": "Aggiungi un documento d'identità.",
    "auth.onlyAdults": "Riservato ai maggiori di 18 anni.",
    "home.yourBalance": "Il tuo saldo",
    "home.recharge": "Ricarica",
    "home.received": "Foto ricevute",
    "home.noPhotos": "Ancora nessuna foto",
    "home.noPhotosHint": "Aggiungi amici per ricevere foto bloccate.",
    "home.findFriends": "Trova amici",
    "home.count": "pubblicazione/i",
    "explore.title": "Esplora",
    "explore.searchPlaceholder": "Cerca creator, #hashtag, suoni…",
    "explore.creators": "Creator",
    "explore.hashtags": "Hashtag",
    "explore.sounds": "Suoni",
    "explore.trendingTags": "Hashtag di tendenza",
    "explore.trendingSounds": "Suoni di tendenza",
    "explore.suggested": "Creator suggeriti",
    "explore.noResults": "Nessun risultato",
    "profile.title": "Profilo",
    "profile.balance": "Saldo",
    "profile.earnings": "Guadagni",
    "profile.sold": "Vendute",
    "profile.private": "Account privato",
    "profile.privateDesc": "Solo i tuoi amici possono inviarti foto.",
    "profile.creatorSub": "Abbonamento creator",
    "profile.creatorSubDesc": "Accesso mensile a tutte le tue foto (piani Stripe).",
    "profile.locked": "Bloccato",
    "profile.subGate": "Sbloccato a partire da",
    "profile.subscribers": "iscritti — ne hai",
    "profile.language": "Lingua",
    "profile.languageDesc": "Scegli la lingua dell'interfaccia.",
    "profile.avatarChange": "Cambia foto",
    "profile.publications": "Pubblicazioni",
    "profile.photosPublished": "Foto",
    "profile.videosPublished": "Video",
    "profile.myWall": "Vedi la mia bacheca pubblica",
    "profile.subscribersCount": "Iscritti",
    "profile.mySubs": "I miei abbonamenti",
    "profile.yourSubscribers": "I tuoi iscritti",
    "profile.blocked": "Utenti bloccati",
    "profile.noBlocked": "Nessun utente bloccato.",
    "profile.unblock": "Sblocca",
    "profile.tos": "Termini di utilizzo",
    "profile.safety": "Sicurezza e moderazione",
    "profile.logout": "Esci",
    "profile.kycPending": "Verifica dell'identità in attesa",
    "profile.kycApproved": "Identità verificata",
    "account.title": "Modifica account",
    "account.desc": "Aggiorna nome utente, email o password.",
    "account.edit": "Modifica",
    "account.info": "Informazioni",
    "account.currentPassword": "Password attuale",
    "account.saveInfo": "Salva",
    "account.changePassword": "Cambia password",
    "account.infoSaved": "Account aggiornato",
    "account.passwordChanged": "Password modificata",
    "send.title": "Invia contenuto",
    "send.recipient": "Destinatario",
    "send.noFriends": "Nessun amico disponibile",
    "send.add": "Aggiungi",
    "send.media": "Contenuto",
    "send.choosePhoto": "Scegli una foto o un video",
    "send.formats": "JPG, PNG, MP4 • foto max 8 MB",
    "send.changeMedia": "Cambia contenuto",
    "send.willLock": "Sarà bloccato a",
    "send.price": "Prezzo di sblocco",
    "send.youEarn": "Guadagnerai",
    "send.caption": "Didascalia (facoltativa)",
    "send.captionPlaceholder": "Aggiungi un messaggio…",
    "send.submit": "Invia contenuto bloccato",
    "send.sending": "Invio…",
    "send.noMax": "Nessun limite di prezzo — minimo 1 €",
    "conv.start": "Inizia la conversazione o invia una foto bloccata.",
    "conv.write": "Scrivi un messaggio…",
    "conv.requestPhoto": "Richiedi una foto",
    "conv.sendPhoto": "Invia una foto",
    "conv.translating": "Traduzione…",
    "wall.title": "La mia bacheca creator",
    "wall.subtitle": "Pubblica foto e video a pagamento visibili a tutti.",
    "wall.publish": "Nuova pubblicazione",
    "wall.publishTo": "Pubblica sulla mia bacheca",
    "wall.empty": "Ancora nessuna pubblicazione.",
    "wall.emptyHint": "Aggiungi la tua prima foto o video a pagamento.",
    "wall.visitVitrine": "Vedi la mia vetrina",
    "wall.published": "Pubblicazione aggiunta alla tua bacheca",
    "wall.creatorPage": "Pagina creator",
    "wall.posts": "pubblicazioni",
    "wall.subscribeToUnlock": "Iscriviti per sbloccare tutto",
    "wall.notFound": "Creator non trovato",
    "wall.by": "Pubblicazioni di",
    "wallet.title": "Portafoglio",
  },
  ro: {
    "common.loading": "Se încarcă…",
    "common.cancel": "Anulează",
    "common.save": "Salvează",
    "common.send": "Trimite",
    "common.close": "Închide",
    "common.delete": "Șterge",
    "common.subscribe": "Abonează-te",
    "common.subscribed": "Abonat",
    "common.unlock": "Deblochează",
    "common.locked": "Blocat",
    "common.unlocked": "Deblocat",
    "common.photo": "Foto",
    "common.video": "Video",
    "common.publish": "Publică",
    "common.translate": "Traduce",
    "common.showOriginal": "Arată originalul",
    "common.pleaseWait": "Așteptați…",
    "nav.home": "Acasă",
    "nav.friends": "Prieteni",
    "nav.send": "Trimite",
    "nav.wallet": "Portofel",
    "nav.profile": "Profil",
    "nav.wall": "Peretele meu",
    "auth.login": "Autentificare",
    "auth.register": "Înregistrare",
    "auth.email": "Email",
    "auth.password": "Parolă",
    "auth.username": "Nume utilizator",
    "auth.signIn": "Conectează-te",
    "auth.createAccount": "Creează cont",
    "auth.age": "Confirm că am 18 ani sau mai mult și accept Termenii de utilizare și regulile de conținut.",
    "auth.idUpload": "Act de identitate (verificare vârstă)",
    "auth.idUploadHint": "Obligatoriu la înregistrare. Folosit pentru moderarea 18+.",
    "auth.idAdd": "Adaugă actul de identitate",
    "auth.idAdded": "Act de identitate adăugat",
    "auth.forgot": "Ai uitat parola?",
    "auth.reset": "Resetează parola",
    "auth.resetHint": "Introdu emailul pentru a primi un link de resetare.",
    "auth.newPassword": "Parolă nouă",
    "auth.backToLogin": "Înapoi la autentificare",
    "auth.welcome": "Bine ai venit pe MIHOD PAY!",
    "auth.tagline": "Distribuie foto private. La prețul tău.",
    "auth.subtitle": "Trimite unui prieten o foto blocată. Se deblochează doar după plată — iar tu primești 80% din fiecare vânzare.",
    "auth.ageError": "Trebuie să confirmi că ai 18 ani sau mai mult.",
    "auth.idError": "Te rugăm să adaugi un act de identitate.",
    "auth.onlyAdults": "Doar pentru persoane de 18 ani și peste.",
    "home.yourBalance": "Soldul tău",
    "home.recharge": "Reîncarcă",
    "home.received": "Foto primite",
    "home.noPhotos": "Încă nicio foto",
    "home.noPhotosHint": "Adaugă prieteni pentru a primi foto blocate.",
    "home.findFriends": "Găsește prieteni",
    "home.count": "postare(i)",
    "explore.title": "Explorează",
    "explore.searchPlaceholder": "Caută creatori, #hashtaguri, sunete…",
    "explore.creators": "Creatori",
    "explore.hashtags": "Hashtaguri",
    "explore.sounds": "Sunete",
    "explore.trendingTags": "Hashtaguri populare",
    "explore.trendingSounds": "Sunete populare",
    "explore.suggested": "Creatori sugerați",
    "explore.noResults": "Niciun rezultat",
    "profile.title": "Profil",
    "profile.balance": "Sold",
    "profile.earnings": "Venituri",
    "profile.sold": "Vândute",
    "profile.private": "Cont privat",
    "profile.privateDesc": "Doar prietenii tăi îți pot trimite foto.",
    "profile.creatorSub": "Abonament creator",
    "profile.creatorSubDesc": "Acces lunar la toate foto tale (planuri Stripe).",
    "profile.locked": "Blocat",
    "profile.subGate": "Deblocat începând de la",
    "profile.subscribers": "abonați — ai",
    "profile.language": "Limbă",
    "profile.languageDesc": "Alege limba interfeței.",
    "profile.avatarChange": "Schimbă poza",
    "profile.publications": "Postări",
    "profile.photosPublished": "Foto",
    "profile.videosPublished": "Video",
    "profile.myWall": "Vezi peretele meu public",
    "profile.subscribersCount": "Abonați",
    "profile.mySubs": "Abonamentele mele",
    "profile.yourSubscribers": "Abonații tăi",
    "profile.blocked": "Utilizatori blocați",
    "profile.noBlocked": "Niciun utilizator blocat.",
    "profile.unblock": "Deblochează",
    "profile.tos": "Termeni de utilizare",
    "profile.safety": "Siguranță și moderare",
    "profile.logout": "Deconectare",
    "profile.kycPending": "Verificarea identității în așteptare",
    "profile.kycApproved": "Identitate verificată",
    "account.title": "Editează contul",
    "account.desc": "Actualizează numele de utilizator, emailul sau parola.",
    "account.edit": "Editează",
    "account.info": "Informații",
    "account.currentPassword": "Parola actuală",
    "account.saveInfo": "Salvează",
    "account.changePassword": "Schimbă parola",
    "account.infoSaved": "Cont actualizat",
    "account.passwordChanged": "Parolă schimbată",
    "send.title": "Trimite conținut",
    "send.recipient": "Destinatar",
    "send.noFriends": "Niciun prieten disponibil",
    "send.add": "Adaugă",
    "send.media": "Conținut",
    "send.choosePhoto": "Alege o foto sau un video",
    "send.formats": "JPG, PNG, MP4 • foto max 8 MB",
    "send.changeMedia": "Schimbă conținutul",
    "send.willLock": "Va fi blocat la",
    "send.price": "Preț de deblocare",
    "send.youEarn": "Vei primi",
    "send.caption": "Descriere (opțional)",
    "send.captionPlaceholder": "Adaugă un mesaj…",
    "send.submit": "Trimite conținut blocat",
    "send.sending": "Se trimite…",
    "send.noMax": "Fără limită de preț — minim 1 €",
    "conv.start": "Începe conversația sau trimite o foto blocată.",
    "conv.write": "Scrie un mesaj…",
    "conv.requestPhoto": "Cere o foto",
    "conv.sendPhoto": "Trimite o foto",
    "conv.translating": "Se traduce…",
    "wall.title": "Peretele meu de creator",
    "wall.subtitle": "Publică foto și video cu plată, vizibile pentru toți.",
    "wall.publish": "Postare nouă",
    "wall.publishTo": "Publică pe peretele meu",
    "wall.empty": "Încă nicio postare.",
    "wall.emptyHint": "Adaugă prima ta foto sau video cu plată.",
    "wall.visitVitrine": "Vezi pagina mea vitrină",
    "wall.published": "Postare adăugată pe peretele tău",
    "wall.creatorPage": "Pagină de creator",
    "wall.posts": "postări",
    "wall.subscribeToUnlock": "Abonează-te pentru a debloca tot",
    "wall.notFound": "Creator negăsit",
    "wall.by": "Postări de",
    "wallet.title": "Portofel",
  },
  tr: {
    "common.loading": "Yükleniyor…",
    "common.cancel": "İptal",
    "common.save": "Kaydet",
    "common.send": "Gönder",
    "common.close": "Kapat",
    "common.delete": "Sil",
    "common.subscribe": "Abone ol",
    "common.subscribed": "Abone olundu",
    "common.unlock": "Kilidi aç",
    "common.locked": "Kilitli",
    "common.unlocked": "Kilidi açıldı",
    "common.photo": "Fotoğraf",
    "common.video": "Video",
    "common.publish": "Yayınla",
    "common.translate": "Çevir",
    "common.showOriginal": "Orijinali göster",
    "common.pleaseWait": "Lütfen bekleyin…",
    "nav.home": "Ana sayfa",
    "nav.friends": "Arkadaşlar",
    "nav.send": "Gönder",
    "nav.wallet": "Cüzdan",
    "nav.profile": "Profil",
    "nav.wall": "Duvarım",
    "auth.login": "Giriş",
    "auth.register": "Kayıt ol",
    "auth.email": "E-posta",
    "auth.password": "Şifre",
    "auth.username": "Kullanıcı adı",
    "auth.signIn": "Giriş yap",
    "auth.createAccount": "Hesabımı oluştur",
    "auth.age": "18 yaşında veya daha büyük olduğumu onaylıyorum ve Kullanım Koşulları ile içerik kurallarını kabul ediyorum.",
    "auth.idUpload": "Kimlik (yaş doğrulama)",
    "auth.idUploadHint": "Kayıt için zorunludur. 18+ moderasyonu için kullanılır.",
    "auth.idAdd": "Kimliğimi ekle",
    "auth.idAdded": "Kimlik eklendi",
    "auth.forgot": "Şifreni mi unuttun?",
    "auth.reset": "Şifreyi sıfırla",
    "auth.resetHint": "Sıfırlama bağlantısı almak için e-postanı gir.",
    "auth.newPassword": "Yeni şifre",
    "auth.backToLogin": "Girişe dön",
    "auth.welcome": "MIHOD PAY'e hoş geldin!",
    "auth.tagline": "Özel fotoğraflar paylaş. Senin fiyatınla.",
    "auth.subtitle": "Bir arkadaşına kilitli fotoğraf gönder. Yalnızca ödeme sonrası açılır — ve her satıştan %80 kazanırsın.",
    "auth.ageError": "18 yaşında veya daha büyük olduğunu onaylamalısın.",
    "auth.idError": "Lütfen bir kimlik ekle.",
    "auth.onlyAdults": "Yalnızca 18 yaş ve üzeri için.",
    "home.yourBalance": "Bakiyen",
    "home.recharge": "Yükle",
    "home.received": "Gelen fotoğraflar",
    "home.noPhotos": "Henüz fotoğraf yok",
    "home.noPhotosHint": "Kilitli fotoğraf almak için arkadaş ekle.",
    "home.findFriends": "Arkadaş bul",
    "home.count": "gönderi",
    "explore.title": "Keşfet",
    "explore.searchPlaceholder": "Üretici, #hashtag, ses ara…",
    "explore.creators": "Üreticiler",
    "explore.hashtags": "Hashtag'ler",
    "explore.sounds": "Sesler",
    "explore.trendingTags": "Trend hashtag'ler",
    "explore.trendingSounds": "Trend sesler",
    "explore.suggested": "Önerilen üreticiler",
    "explore.noResults": "Sonuç yok",
    "profile.title": "Profil",
    "profile.balance": "Bakiye",
    "profile.earnings": "Kazançlar",
    "profile.sold": "Satıldı",
    "profile.private": "Gizli hesap",
    "profile.privateDesc": "Sana yalnızca arkadaşların fotoğraf gönderebilir.",
    "profile.creatorSub": "Üretici aboneliği",
    "profile.creatorSubDesc": "Tüm fotoğraflarına aylık erişim (Stripe planları).",
    "profile.locked": "Kilitli",
    "profile.subGate": "Şu tutardan itibaren açık",
    "profile.subscribers": "abone — sende var",
    "profile.language": "Dil",
    "profile.languageDesc": "Arayüz dilini seç.",
    "profile.avatarChange": "Fotoğrafı değiştir",
    "profile.publications": "Gönderiler",
    "profile.photosPublished": "Fotoğraflar",
    "profile.videosPublished": "Videolar",
    "profile.myWall": "Herkese açık duvarımı gör",
    "profile.subscribersCount": "Aboneler",
    "profile.mySubs": "Aboneliklerim",
    "profile.yourSubscribers": "Abonelerin",
    "profile.blocked": "Engellenen kullanıcılar",
    "profile.noBlocked": "Engellenen kullanıcı yok.",
    "profile.unblock": "Engeli kaldır",
    "profile.tos": "Kullanım koşulları",
    "profile.safety": "Güvenlik ve moderasyon",
    "profile.logout": "Çıkış yap",
    "profile.kycPending": "Kimlik doğrulaması bekleniyor",
    "profile.kycApproved": "Kimlik doğrulandı",
    "account.title": "Hesabı düzenle",
    "account.desc": "Kullanıcı adını, e-postanı veya şifreni güncelle.",
    "account.edit": "Düzenle",
    "account.info": "Bilgiler",
    "account.currentPassword": "Mevcut şifre",
    "account.saveInfo": "Kaydet",
    "account.changePassword": "Şifreyi değiştir",
    "account.infoSaved": "Hesap güncellendi",
    "account.passwordChanged": "Şifre değiştirildi",
    "send.title": "Medya gönder",
    "send.recipient": "Alıcı",
    "send.noFriends": "Uygun arkadaş yok",
    "send.add": "Ekle",
    "send.media": "Medya",
    "send.choosePhoto": "Bir fotoğraf veya video seç",
    "send.formats": "JPG, PNG, MP4 • fotoğraf en fazla 8 MB",
    "send.changeMedia": "Medyayı değiştir",
    "send.willLock": "Şu tutarda kilitlenecek",
    "send.price": "Kilit açma fiyatı",
    "send.youEarn": "Kazancın",
    "send.caption": "Açıklama (isteğe bağlı)",
    "send.captionPlaceholder": "Bir mesaj ekle…",
    "send.submit": "Kilitli medyayı gönder",
    "send.sending": "Gönderiliyor…",
    "send.noMax": "Fiyat sınırı yok — en az 1 €",
    "conv.start": "Sohbete başla veya kilitli bir fotoğraf gönder.",
    "conv.write": "Bir mesaj yaz…",
    "conv.requestPhoto": "Fotoğraf iste",
    "conv.sendPhoto": "Fotoğraf gönder",
    "conv.translating": "Çevriliyor…",
    "wall.title": "Üretici duvarım",
    "wall.subtitle": "Herkesin görebileceği ücretli fotoğraf ve videolar yayınla.",
    "wall.publish": "Yeni gönderi",
    "wall.publishTo": "Duvarımda yayınla",
    "wall.empty": "Henüz gönderi yok.",
    "wall.emptyHint": "İlk ücretli fotoğrafını veya videonu ekle.",
    "wall.visitVitrine": "Vitrin sayfamı gör",
    "wall.published": "Gönderi duvarına eklendi",
    "wall.creatorPage": "Üretici sayfası",
    "wall.posts": "gönderi",
    "wall.subscribeToUnlock": "Her şeyi açmak için abone ol",
    "wall.notFound": "Üretici bulunamadı",
    "wall.by": "Gönderiler:",
    "wallet.title": "Cüzdan",
  },
  ar: {
    "common.loading": "جارٍ التحميل…",
    "common.cancel": "إلغاء",
    "common.save": "حفظ",
    "common.send": "إرسال",
    "common.close": "إغلاق",
    "common.delete": "حذف",
    "common.subscribe": "اشترك",
    "common.subscribed": "مشترك",
    "common.unlock": "فتح",
    "common.locked": "مقفل",
    "common.unlocked": "مفتوح",
    "common.photo": "صورة",
    "common.video": "فيديو",
    "common.publish": "نشر",
    "common.translate": "ترجمة",
    "common.showOriginal": "عرض الأصل",
    "common.pleaseWait": "يرجى الانتظار…",
    "nav.home": "الرئيسية",
    "nav.friends": "الأصدقاء",
    "nav.send": "إرسال",
    "nav.wallet": "المحفظة",
    "nav.profile": "الملف",
    "nav.wall": "جداري",
    "auth.login": "تسجيل الدخول",
    "auth.register": "إنشاء حساب",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.username": "اسم المستخدم",
    "auth.signIn": "دخول",
    "auth.createAccount": "إنشاء حسابي",
    "auth.age": "أؤكد أن عمري 18 عامًا أو أكثر وأوافق على شروط الاستخدام وقواعد المحتوى.",
    "auth.idUpload": "بطاقة الهوية (التحقق من العمر)",
    "auth.idUploadHint": "إلزامية للتسجيل. تُستخدم للإشراف على المحتوى 18+.",
    "auth.idAdd": "أضف هويتي",
    "auth.idAdded": "تمت إضافة الهوية",
    "auth.forgot": "هل نسيت كلمة المرور؟",
    "auth.reset": "إعادة تعيين كلمة المرور",
    "auth.resetHint": "أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين.",
    "auth.newPassword": "كلمة مرور جديدة",
    "auth.backToLogin": "العودة لتسجيل الدخول",
    "auth.welcome": "مرحبًا بك في MIHOD PAY!",
    "auth.tagline": "شارك صورًا خاصة. بسعرك أنت.",
    "auth.subtitle": "أرسل صورة مقفلة لصديق. لا تُفتح إلا بعد الدفع — وتحصل على 80% من كل عملية بيع.",
    "auth.ageError": "يجب أن تؤكد أن عمرك 18 عامًا أو أكثر.",
    "auth.idError": "يرجى إضافة بطاقة هوية.",
    "auth.onlyAdults": "للبالغين 18 عامًا فأكثر فقط.",
    "home.yourBalance": "رصيدك",
    "home.recharge": "إعادة الشحن",
    "home.received": "الصور المستلمة",
    "home.noPhotos": "لا توجد صور بعد",
    "home.noPhotosHint": "أضف أصدقاء لتلقي صور مقفلة.",
    "home.findFriends": "ابحث عن أصدقاء",
    "home.count": "منشور/منشورات",
    "explore.title": "استكشف",
    "explore.searchPlaceholder": "ابحث عن صنّاع، #وسوم، أصوات…",
    "explore.creators": "الصنّاع",
    "explore.hashtags": "الوسوم",
    "explore.sounds": "الأصوات",
    "explore.trendingTags": "وسوم رائجة",
    "explore.trendingSounds": "أصوات رائجة",
    "explore.suggested": "صنّاع مقترحون",
    "explore.noResults": "لا نتائج",
    "profile.title": "الملف الشخصي",
    "profile.balance": "الرصيد",
    "profile.earnings": "الأرباح",
    "profile.sold": "المُباعة",
    "profile.private": "حساب خاص",
    "profile.privateDesc": "أصدقاؤك فقط يمكنهم إرسال الصور إليك.",
    "profile.creatorSub": "اشتراك الصانع",
    "profile.creatorSubDesc": "وصول شهري لكل صورك (خطط Stripe).",
    "profile.locked": "مقفل",
    "profile.subGate": "مفتوح ابتداءً من",
    "profile.subscribers": "مشترك — لديك",
    "profile.language": "اللغة",
    "profile.languageDesc": "اختر لغة الواجهة.",
    "profile.avatarChange": "تغيير الصورة",
    "profile.publications": "المنشورات",
    "profile.photosPublished": "الصور",
    "profile.videosPublished": "الفيديوهات",
    "profile.myWall": "عرض جداري العام",
    "profile.subscribersCount": "المشتركون",
    "profile.mySubs": "اشتراكاتي",
    "profile.yourSubscribers": "مشتركوك",
    "profile.blocked": "المستخدمون المحظورون",
    "profile.noBlocked": "لا يوجد مستخدمون محظورون.",
    "profile.unblock": "إلغاء الحظر",
    "profile.tos": "شروط الاستخدام",
    "profile.safety": "الأمان والإشراف",
    "profile.logout": "تسجيل الخروج",
    "profile.kycPending": "التحقق من الهوية قيد الانتظار",
    "profile.kycApproved": "تم التحقق من الهوية",
    "account.title": "تعديل الحساب",
    "account.desc": "حدّث اسم المستخدم أو البريد أو كلمة المرور.",
    "account.edit": "تعديل",
    "account.info": "المعلومات",
    "account.currentPassword": "كلمة المرور الحالية",
    "account.saveInfo": "حفظ",
    "account.changePassword": "تغيير كلمة المرور",
    "account.infoSaved": "تم تحديث الحساب",
    "account.passwordChanged": "تم تغيير كلمة المرور",
    "send.title": "إرسال وسائط",
    "send.recipient": "المستلم",
    "send.noFriends": "لا يوجد أصدقاء متاحون",
    "send.add": "إضافة",
    "send.media": "الوسائط",
    "send.choosePhoto": "اختر صورة أو فيديو",
    "send.formats": "JPG, PNG, MP4 • الصورة بحد أقصى 8 ميغابايت",
    "send.changeMedia": "تغيير الوسائط",
    "send.willLock": "سيتم القفل عند",
    "send.price": "سعر الفتح",
    "send.youEarn": "ستحصل على",
    "send.caption": "التعليق (اختياري)",
    "send.captionPlaceholder": "أضف رسالة…",
    "send.submit": "إرسال الوسائط المقفلة",
    "send.sending": "جارٍ الإرسال…",
    "send.noMax": "لا حد للسعر — الحد الأدنى 1 €",
    "conv.start": "ابدأ المحادثة أو أرسل صورة مقفلة.",
    "conv.write": "اكتب رسالة…",
    "conv.requestPhoto": "طلب صورة",
    "conv.sendPhoto": "إرسال صورة",
    "conv.translating": "جارٍ الترجمة…",
    "wall.title": "جدار الصانع الخاص بي",
    "wall.subtitle": "انشر صورًا وفيديوهات مدفوعة يراها الجميع.",
    "wall.publish": "منشور جديد",
    "wall.publishTo": "النشر على جداري",
    "wall.empty": "لا منشورات بعد.",
    "wall.emptyHint": "أضف أول صورة أو فيديو مدفوع لك.",
    "wall.visitVitrine": "عرض صفحة العرض الخاصة بي",
    "wall.published": "تمت إضافة المنشور إلى جدارك",
    "wall.creatorPage": "صفحة الصانع",
    "wall.posts": "منشورات",
    "wall.subscribeToUnlock": "اشترك لفتح كل شيء",
    "wall.notFound": "الصانع غير موجود",
    "wall.by": "منشورات من",
    "wallet.title": "المحفظة",
  },
  hi: {
    "common.loading": "लोड हो रहा है…",
    "common.cancel": "रद्द करें",
    "common.save": "सहेजें",
    "common.send": "भेजें",
    "common.close": "बंद करें",
    "common.delete": "हटाएँ",
    "common.subscribe": "सब्सक्राइब",
    "common.subscribed": "सब्सक्राइब किया",
    "common.unlock": "अनलॉक",
    "common.locked": "लॉक",
    "common.unlocked": "अनलॉक हो गया",
    "common.photo": "फ़ोटो",
    "common.video": "वीडियो",
    "common.publish": "प्रकाशित करें",
    "common.translate": "अनुवाद",
    "common.showOriginal": "मूल दिखाएँ",
    "common.pleaseWait": "कृपया प्रतीक्षा करें…",
    "nav.home": "होम",
    "nav.friends": "मित्र",
    "nav.send": "भेजें",
    "nav.wallet": "वॉलेट",
    "nav.profile": "प्रोफ़ाइल",
    "nav.wall": "मेरी वॉल",
    "auth.login": "लॉगिन",
    "auth.register": "रजिस्टर",
    "auth.email": "ईमेल",
    "auth.password": "पासवर्ड",
    "auth.username": "यूज़रनेम",
    "auth.signIn": "साइन इन",
    "auth.createAccount": "मेरा खाता बनाएँ",
    "auth.age": "मैं पुष्टि करता/करती हूँ कि मेरी उम्र 18 वर्ष या अधिक है और मैं उपयोग की शर्तें व सामग्री नियम स्वीकार करता/करती हूँ।",
    "auth.idUpload": "पहचान पत्र (आयु सत्यापन)",
    "auth.idUploadHint": "पंजीकरण के लिए अनिवार्य। 18+ मॉडरेशन के लिए उपयोग होता है।",
    "auth.idAdd": "मेरा पहचान पत्र जोड़ें",
    "auth.idAdded": "पहचान पत्र जोड़ा गया",
    "auth.forgot": "पासवर्ड भूल गए?",
    "auth.reset": "पासवर्ड रीसेट करें",
    "auth.resetHint": "रीसेट लिंक पाने के लिए अपना ईमेल दर्ज करें।",
    "auth.newPassword": "नया पासवर्ड",
    "auth.backToLogin": "लॉगिन पर वापस जाएँ",
    "auth.welcome": "MIHOD PAY में आपका स्वागत है!",
    "auth.tagline": "निजी फ़ोटो साझा करें। अपनी कीमत पर।",
    "auth.subtitle": "किसी मित्र को लॉक फ़ोटो भेजें। यह केवल भुगतान के बाद अनलॉक होती है — और हर बिक्री पर आपको 80% मिलता है।",
    "auth.ageError": "आपको पुष्टि करनी होगी कि आपकी उम्र 18 वर्ष या अधिक है।",
    "auth.idError": "कृपया एक पहचान पत्र जोड़ें।",
    "auth.onlyAdults": "केवल 18 वर्ष व उससे अधिक के लिए।",
    "home.yourBalance": "आपका बैलेंस",
    "home.recharge": "रिचार्ज",
    "home.received": "प्राप्त फ़ोटो",
    "home.noPhotos": "अभी कोई फ़ोटो नहीं",
    "home.noPhotosHint": "लॉक फ़ोटो पाने के लिए मित्र जोड़ें।",
    "home.findFriends": "मित्र खोजें",
    "home.count": "पोस्ट",
    "explore.title": "एक्सप्लोर",
    "explore.searchPlaceholder": "क्रिएटर, #हैशटैग, साउंड खोजें…",
    "explore.creators": "क्रिएटर",
    "explore.hashtags": "हैशटैग",
    "explore.sounds": "साउंड",
    "explore.trendingTags": "ट्रेंडिंग हैशटैग",
    "explore.trendingSounds": "ट्रेंडिंग साउंड",
    "explore.suggested": "सुझाए गए क्रिएटर",
    "explore.noResults": "कोई परिणाम नहीं",
    "profile.title": "प्रोफ़ाइल",
    "profile.balance": "बैलेंस",
    "profile.earnings": "कमाई",
    "profile.sold": "बिकीं",
    "profile.private": "निजी खाता",
    "profile.privateDesc": "केवल आपके मित्र ही आपको फ़ोटो भेज सकते हैं।",
    "profile.creatorSub": "क्रिएटर सब्सक्रिप्शन",
    "profile.creatorSubDesc": "आपकी सभी फ़ोटो तक मासिक पहुँच (Stripe योजनाएँ)।",
    "profile.locked": "लॉक",
    "profile.subGate": "इससे अनलॉक",
    "profile.subscribers": "सब्सक्राइबर — आपके पास",
    "profile.language": "भाषा",
    "profile.languageDesc": "इंटरफ़ेस की भाषा चुनें।",
    "profile.avatarChange": "फ़ोटो बदलें",
    "profile.publications": "पोस्ट",
    "profile.photosPublished": "फ़ोटो",
    "profile.videosPublished": "वीडियो",
    "profile.myWall": "मेरी सार्वजनिक वॉल देखें",
    "profile.subscribersCount": "सब्सक्राइबर",
    "profile.mySubs": "मेरी सब्सक्रिप्शन",
    "profile.yourSubscribers": "आपके सब्सक्राइबर",
    "profile.blocked": "ब्लॉक किए उपयोगकर्ता",
    "profile.noBlocked": "कोई ब्लॉक उपयोगकर्ता नहीं।",
    "profile.unblock": "अनब्लॉक",
    "profile.tos": "उपयोग की शर्तें",
    "profile.safety": "सुरक्षा और मॉडरेशन",
    "profile.logout": "लॉग आउट",
    "profile.kycPending": "पहचान सत्यापन लंबित",
    "profile.kycApproved": "पहचान सत्यापित",
    "account.title": "खाता संपादित करें",
    "account.desc": "यूज़रनेम, ईमेल या पासवर्ड अपडेट करें।",
    "account.edit": "संपादित करें",
    "account.info": "जानकारी",
    "account.currentPassword": "वर्तमान पासवर्ड",
    "account.saveInfo": "सहेजें",
    "account.changePassword": "पासवर्ड बदलें",
    "account.infoSaved": "खाता अपडेट हुआ",
    "account.passwordChanged": "पासवर्ड बदला गया",
    "send.title": "मीडिया भेजें",
    "send.recipient": "प्राप्तकर्ता",
    "send.noFriends": "कोई मित्र उपलब्ध नहीं",
    "send.add": "जोड़ें",
    "send.media": "मीडिया",
    "send.choosePhoto": "फ़ोटो या वीडियो चुनें",
    "send.formats": "JPG, PNG, MP4 • फ़ोटो अधिकतम 8 MB",
    "send.changeMedia": "मीडिया बदलें",
    "send.willLock": "इस पर लॉक होगा",
    "send.price": "अनलॉक कीमत",
    "send.youEarn": "आपको मिलेगा",
    "send.caption": "कैप्शन (वैकल्पिक)",
    "send.captionPlaceholder": "एक संदेश जोड़ें…",
    "send.submit": "लॉक मीडिया भेजें",
    "send.sending": "भेजा जा रहा है…",
    "send.noMax": "कोई कीमत सीमा नहीं — न्यूनतम 1 €",
    "conv.start": "बातचीत शुरू करें या लॉक फ़ोटो भेजें।",
    "conv.write": "एक संदेश लिखें…",
    "conv.requestPhoto": "फ़ोटो का अनुरोध करें",
    "conv.sendPhoto": "फ़ोटो भेजें",
    "conv.translating": "अनुवाद हो रहा है…",
    "wall.title": "मेरी क्रिएटर वॉल",
    "wall.subtitle": "सभी को दिखने वाली सशुल्क फ़ोटो व वीडियो प्रकाशित करें।",
    "wall.publish": "नई पोस्ट",
    "wall.publishTo": "मेरी वॉल पर प्रकाशित करें",
    "wall.empty": "अभी कोई पोस्ट नहीं।",
    "wall.emptyHint": "अपनी पहली सशुल्क फ़ोटो या वीडियो जोड़ें।",
    "wall.visitVitrine": "मेरा शोकेस पेज देखें",
    "wall.published": "पोस्ट आपकी वॉल पर जोड़ी गई",
    "wall.creatorPage": "क्रिएटर पेज",
    "wall.posts": "पोस्ट",
    "wall.subscribeToUnlock": "सब कुछ अनलॉक करने के लिए सब्सक्राइब करें",
    "wall.notFound": "क्रिएटर नहीं मिला",
    "wall.by": "इनकी पोस्ट:",
    "wallet.title": "वॉलेट",
  },
  bn: {
    "common.loading": "লোড হচ্ছে…",
    "common.cancel": "বাতিল",
    "common.save": "সংরক্ষণ",
    "common.send": "পাঠান",
    "common.close": "বন্ধ",
    "common.delete": "মুছুন",
    "common.subscribe": "সাবস্ক্রাইব",
    "common.subscribed": "সাবস্ক্রাইব করা",
    "common.unlock": "আনলক",
    "common.locked": "লক করা",
    "common.unlocked": "আনলক করা",
    "common.photo": "ছবি",
    "common.video": "ভিডিও",
    "common.publish": "প্রকাশ",
    "common.translate": "অনুবাদ",
    "common.showOriginal": "মূল দেখান",
    "common.pleaseWait": "অনুগ্রহ করে অপেক্ষা করুন…",
    "nav.home": "হোম",
    "nav.friends": "বন্ধুরা",
    "nav.send": "পাঠান",
    "nav.wallet": "ওয়ালেট",
    "nav.profile": "প্রোফাইল",
    "nav.wall": "আমার ওয়াল",
    "auth.login": "লগইন",
    "auth.register": "নিবন্ধন",
    "auth.email": "ইমেল",
    "auth.password": "পাসওয়ার্ড",
    "auth.username": "ইউজারনেম",
    "auth.signIn": "সাইন ইন",
    "auth.createAccount": "আমার অ্যাকাউন্ট তৈরি করুন",
    "auth.age": "আমি নিশ্চিত করছি যে আমার বয়স ১৮ বা তার বেশি এবং আমি ব্যবহারের শর্তাবলী ও কনটেন্ট নিয়ম মেনে নিচ্ছি।",
    "auth.idUpload": "পরিচয়পত্র (বয়স যাচাই)",
    "auth.idUploadHint": "নিবন্ধনের জন্য বাধ্যতামূলক। ১৮+ মডারেশনে ব্যবহৃত।",
    "auth.idAdd": "আমার পরিচয়পত্র যোগ করুন",
    "auth.idAdded": "পরিচয়পত্র যোগ হয়েছে",
    "auth.forgot": "পাসওয়ার্ড ভুলে গেছেন?",
    "auth.reset": "পাসওয়ার্ড রিসেট",
    "auth.resetHint": "রিসেট লিংক পেতে আপনার ইমেল দিন।",
    "auth.newPassword": "নতুন পাসওয়ার্ড",
    "auth.backToLogin": "লগইনে ফিরে যান",
    "auth.welcome": "MIHOD PAY-তে স্বাগতম!",
    "auth.tagline": "ব্যক্তিগত ছবি শেয়ার করুন। আপনার দামে।",
    "auth.subtitle": "বন্ধুকে একটি লক করা ছবি পাঠান। এটি কেবল পেমেন্টের পরেই আনলক হয় — এবং প্রতিটি বিক্রয়ে আপনি ৮০% পান।",
    "auth.ageError": "আপনাকে নিশ্চিত করতে হবে যে আপনার বয়স ১৮ বা তার বেশি।",
    "auth.idError": "অনুগ্রহ করে একটি পরিচয়পত্র যোগ করুন।",
    "auth.onlyAdults": "শুধুমাত্র ১৮ বছর ও তার বেশি বয়সীদের জন্য।",
    "home.yourBalance": "আপনার ব্যালেন্স",
    "home.recharge": "রিচার্জ",
    "home.received": "প্রাপ্ত ছবি",
    "home.noPhotos": "এখনও কোনো ছবি নেই",
    "home.noPhotosHint": "লক করা ছবি পেতে বন্ধু যোগ করুন।",
    "home.findFriends": "বন্ধু খুঁজুন",
    "home.count": "পোস্ট",
    "explore.title": "এক্সপ্লোর",
    "explore.searchPlaceholder": "ক্রিয়েটর, #হ্যাশট্যাগ, সাউন্ড খুঁজুন…",
    "explore.creators": "ক্রিয়েটর",
    "explore.hashtags": "হ্যাশট্যাগ",
    "explore.sounds": "সাউন্ড",
    "explore.trendingTags": "ট্রেন্ডিং হ্যাশট্যাগ",
    "explore.trendingSounds": "ট্রেন্ডিং সাউন্ড",
    "explore.suggested": "প্রস্তাবিত ক্রিয়েটর",
    "explore.noResults": "কোনো ফলাফল নেই",
    "profile.title": "প্রোফাইল",
    "profile.balance": "ব্যালেন্স",
    "profile.earnings": "আয়",
    "profile.sold": "বিক্রি হয়েছে",
    "profile.private": "ব্যক্তিগত অ্যাকাউন্ট",
    "profile.privateDesc": "শুধু আপনার বন্ধুরাই আপনাকে ছবি পাঠাতে পারবে।",
    "profile.creatorSub": "ক্রিয়েটর সাবস্ক্রিপশন",
    "profile.creatorSubDesc": "আপনার সব ছবিতে মাসিক অ্যাক্সেস (Stripe প্ল্যান)।",
    "profile.locked": "লক করা",
    "profile.subGate": "এখান থেকে আনলক",
    "profile.subscribers": "সাবস্ক্রাইবার — আপনার আছে",
    "profile.language": "ভাষা",
    "profile.languageDesc": "ইন্টারফেসের ভাষা নির্বাচন করুন।",
    "profile.avatarChange": "ছবি পরিবর্তন",
    "profile.publications": "পোস্ট",
    "profile.photosPublished": "ছবি",
    "profile.videosPublished": "ভিডিও",
    "profile.myWall": "আমার পাবলিক ওয়াল দেখুন",
    "profile.subscribersCount": "সাবস্ক্রাইবার",
    "profile.mySubs": "আমার সাবস্ক্রিপশন",
    "profile.yourSubscribers": "আপনার সাবস্ক্রাইবার",
    "profile.blocked": "ব্লক করা ব্যবহারকারী",
    "profile.noBlocked": "কোনো ব্লক করা ব্যবহারকারী নেই।",
    "profile.unblock": "আনব্লক",
    "profile.tos": "ব্যবহারের শর্তাবলী",
    "profile.safety": "নিরাপত্তা ও মডারেশন",
    "profile.logout": "লগআউট",
    "profile.kycPending": "পরিচয় যাচাই বিচারাধীন",
    "profile.kycApproved": "পরিচয় যাচাই হয়েছে",
    "account.title": "অ্যাকাউন্ট সম্পাদনা",
    "account.desc": "ইউজারনেম, ইমেল বা পাসওয়ার্ড আপডেট করুন।",
    "account.edit": "সম্পাদনা",
    "account.info": "তথ্য",
    "account.currentPassword": "বর্তমান পাসওয়ার্ড",
    "account.saveInfo": "সংরক্ষণ",
    "account.changePassword": "পাসওয়ার্ড পরিবর্তন",
    "account.infoSaved": "অ্যাকাউন্ট আপডেট হয়েছে",
    "account.passwordChanged": "পাসওয়ার্ড পরিবর্তিত",
    "send.title": "মিডিয়া পাঠান",
    "send.recipient": "প্রাপক",
    "send.noFriends": "কোনো বন্ধু নেই",
    "send.add": "যোগ করুন",
    "send.media": "মিডিয়া",
    "send.choosePhoto": "একটি ছবি বা ভিডিও নির্বাচন করুন",
    "send.formats": "JPG, PNG, MP4 • ছবি সর্বোচ্চ ৮ MB",
    "send.changeMedia": "মিডিয়া পরিবর্তন",
    "send.willLock": "এতে লক হবে",
    "send.price": "আনলক মূল্য",
    "send.youEarn": "আপনি পাবেন",
    "send.caption": "ক্যাপশন (ঐচ্ছিক)",
    "send.captionPlaceholder": "একটি বার্তা যোগ করুন…",
    "send.submit": "লক করা মিডিয়া পাঠান",
    "send.sending": "পাঠানো হচ্ছে…",
    "send.noMax": "কোনো মূল্য সীমা নেই — সর্বনিম্ন 1 €",
    "conv.start": "কথোপকথন শুরু করুন বা একটি লক করা ছবি পাঠান।",
    "conv.write": "একটি বার্তা লিখুন…",
    "conv.requestPhoto": "ছবি অনুরোধ করুন",
    "conv.sendPhoto": "ছবি পাঠান",
    "conv.translating": "অনুবাদ হচ্ছে…",
    "wall.title": "আমার ক্রিয়েটর ওয়াল",
    "wall.subtitle": "সবার জন্য দৃশ্যমান পেইড ছবি ও ভিডিও প্রকাশ করুন।",
    "wall.publish": "নতুন পোস্ট",
    "wall.publishTo": "আমার ওয়ালে প্রকাশ করুন",
    "wall.empty": "এখনও কোনো পোস্ট নেই।",
    "wall.emptyHint": "আপনার প্রথম পেইড ছবি বা ভিডিও যোগ করুন।",
    "wall.visitVitrine": "আমার শোকেস পেজ দেখুন",
    "wall.published": "পোস্ট আপনার ওয়ালে যোগ হয়েছে",
    "wall.creatorPage": "ক্রিয়েটর পেজ",
    "wall.posts": "পোস্ট",
    "wall.subscribeToUnlock": "সব আনলক করতে সাবস্ক্রাইব করুন",
    "wall.notFound": "ক্রিয়েটর পাওয়া যায়নি",
    "wall.by": "পোস্ট করেছেন",
    "wallet.title": "ওয়ালেট",
  },
  id: {
    "common.loading": "Memuat…",
    "common.cancel": "Batal",
    "common.save": "Simpan",
    "common.send": "Kirim",
    "common.close": "Tutup",
    "common.delete": "Hapus",
    "common.subscribe": "Langganan",
    "common.subscribed": "Berlangganan",
    "common.unlock": "Buka kunci",
    "common.locked": "Terkunci",
    "common.unlocked": "Terbuka",
    "common.photo": "Foto",
    "common.video": "Video",
    "common.publish": "Terbitkan",
    "common.translate": "Terjemahkan",
    "common.showOriginal": "Tampilkan asli",
    "common.pleaseWait": "Mohon tunggu…",
    "nav.home": "Beranda",
    "nav.friends": "Teman",
    "nav.send": "Kirim",
    "nav.wallet": "Dompet",
    "nav.profile": "Profil",
    "nav.wall": "Dinding saya",
    "auth.login": "Masuk",
    "auth.register": "Daftar",
    "auth.email": "Email",
    "auth.password": "Kata sandi",
    "auth.username": "Nama pengguna",
    "auth.signIn": "Masuk",
    "auth.createAccount": "Buat akun saya",
    "auth.age": "Saya mengonfirmasi berusia 18 tahun atau lebih dan menyetujui Ketentuan Penggunaan serta aturan konten.",
    "auth.idUpload": "Kartu identitas (verifikasi usia)",
    "auth.idUploadHint": "Wajib untuk pendaftaran. Digunakan untuk moderasi 18+.",
    "auth.idAdd": "Tambahkan identitas saya",
    "auth.idAdded": "Identitas ditambahkan",
    "auth.forgot": "Lupa kata sandi?",
    "auth.reset": "Setel ulang kata sandi",
    "auth.resetHint": "Masukkan email Anda untuk menerima tautan setel ulang.",
    "auth.newPassword": "Kata sandi baru",
    "auth.backToLogin": "Kembali ke masuk",
    "auth.welcome": "Selamat datang di MIHOD PAY!",
    "auth.tagline": "Bagikan foto pribadi. Dengan harga Anda.",
    "auth.subtitle": "Kirim foto terkunci ke teman. Terbuka hanya setelah pembayaran — dan Anda mendapat 80% dari setiap penjualan.",
    "auth.ageError": "Anda harus mengonfirmasi berusia 18 tahun atau lebih.",
    "auth.idError": "Silakan tambahkan kartu identitas.",
    "auth.onlyAdults": "Hanya untuk usia 18 tahun ke atas.",
    "home.yourBalance": "Saldo Anda",
    "home.recharge": "Isi ulang",
    "home.received": "Foto diterima",
    "home.noPhotos": "Belum ada foto",
    "home.noPhotosHint": "Tambahkan teman untuk menerima foto terkunci.",
    "home.findFriends": "Cari teman",
    "home.count": "postingan",
    "explore.title": "Jelajahi",
    "explore.searchPlaceholder": "Cari kreator, #tagar, suara…",
    "explore.creators": "Kreator",
    "explore.hashtags": "Tagar",
    "explore.sounds": "Suara",
    "explore.trendingTags": "Tagar tren",
    "explore.trendingSounds": "Suara tren",
    "explore.suggested": "Kreator disarankan",
    "explore.noResults": "Tidak ada hasil",
    "profile.title": "Profil",
    "profile.balance": "Saldo",
    "profile.earnings": "Pendapatan",
    "profile.sold": "Terjual",
    "profile.private": "Akun pribadi",
    "profile.privateDesc": "Hanya teman Anda yang dapat mengirim foto kepada Anda.",
    "profile.creatorSub": "Langganan kreator",
    "profile.creatorSubDesc": "Akses bulanan ke semua foto Anda (paket Stripe).",
    "profile.locked": "Terkunci",
    "profile.subGate": "Terbuka mulai dari",
    "profile.subscribers": "pelanggan — Anda punya",
    "profile.language": "Bahasa",
    "profile.languageDesc": "Pilih bahasa antarmuka.",
    "profile.avatarChange": "Ubah foto",
    "profile.publications": "Postingan",
    "profile.photosPublished": "Foto",
    "profile.videosPublished": "Video",
    "profile.myWall": "Lihat dinding publik saya",
    "profile.subscribersCount": "Pelanggan",
    "profile.mySubs": "Langganan saya",
    "profile.yourSubscribers": "Pelanggan Anda",
    "profile.blocked": "Pengguna diblokir",
    "profile.noBlocked": "Tidak ada pengguna diblokir.",
    "profile.unblock": "Buka blokir",
    "profile.tos": "Ketentuan penggunaan",
    "profile.safety": "Keamanan & moderasi",
    "profile.logout": "Keluar",
    "profile.kycPending": "Verifikasi identitas tertunda",
    "profile.kycApproved": "Identitas terverifikasi",
    "account.title": "Edit akun",
    "account.desc": "Perbarui nama pengguna, email, atau kata sandi.",
    "account.edit": "Edit",
    "account.info": "Informasi",
    "account.currentPassword": "Kata sandi saat ini",
    "account.saveInfo": "Simpan",
    "account.changePassword": "Ubah kata sandi",
    "account.infoSaved": "Akun diperbarui",
    "account.passwordChanged": "Kata sandi diubah",
    "send.title": "Kirim media",
    "send.recipient": "Penerima",
    "send.noFriends": "Tidak ada teman tersedia",
    "send.add": "Tambah",
    "send.media": "Media",
    "send.choosePhoto": "Pilih foto atau video",
    "send.formats": "JPG, PNG, MP4 • foto maks 8 MB",
    "send.changeMedia": "Ganti media",
    "send.willLock": "Akan terkunci pada",
    "send.price": "Harga buka kunci",
    "send.youEarn": "Anda mendapat",
    "send.caption": "Keterangan (opsional)",
    "send.captionPlaceholder": "Tambahkan pesan…",
    "send.submit": "Kirim media terkunci",
    "send.sending": "Mengirim…",
    "send.noMax": "Tanpa batas harga — minimum 1 €",
    "conv.start": "Mulai percakapan atau kirim foto terkunci.",
    "conv.write": "Tulis pesan…",
    "conv.requestPhoto": "Minta foto",
    "conv.sendPhoto": "Kirim foto",
    "conv.translating": "Menerjemahkan…",
    "wall.title": "Dinding kreator saya",
    "wall.subtitle": "Terbitkan foto dan video berbayar yang terlihat oleh semua.",
    "wall.publish": "Postingan baru",
    "wall.publishTo": "Terbitkan di dinding saya",
    "wall.empty": "Belum ada postingan.",
    "wall.emptyHint": "Tambahkan foto atau video berbayar pertama Anda.",
    "wall.visitVitrine": "Lihat halaman etalase saya",
    "wall.published": "Postingan ditambahkan ke dinding Anda",
    "wall.creatorPage": "Halaman kreator",
    "wall.posts": "postingan",
    "wall.subscribeToUnlock": "Berlangganan untuk membuka semua",
    "wall.notFound": "Kreator tidak ditemukan",
    "wall.by": "Postingan oleh",
    "wallet.title": "Dompet",
  },
  vi: {
    "common.loading": "Đang tải…",
    "common.cancel": "Hủy",
    "common.save": "Lưu",
    "common.send": "Gửi",
    "common.close": "Đóng",
    "common.delete": "Xóa",
    "common.subscribe": "Đăng ký",
    "common.subscribed": "Đã đăng ký",
    "common.unlock": "Mở khóa",
    "common.locked": "Đã khóa",
    "common.unlocked": "Đã mở khóa",
    "common.photo": "Ảnh",
    "common.video": "Video",
    "common.publish": "Đăng",
    "common.translate": "Dịch",
    "common.showOriginal": "Xem bản gốc",
    "common.pleaseWait": "Vui lòng đợi…",
    "nav.home": "Trang chủ",
    "nav.friends": "Bạn bè",
    "nav.send": "Gửi",
    "nav.wallet": "Ví",
    "nav.profile": "Hồ sơ",
    "nav.wall": "Tường của tôi",
    "auth.login": "Đăng nhập",
    "auth.register": "Đăng ký",
    "auth.email": "Email",
    "auth.password": "Mật khẩu",
    "auth.username": "Tên người dùng",
    "auth.signIn": "Đăng nhập",
    "auth.createAccount": "Tạo tài khoản",
    "auth.age": "Tôi xác nhận đủ 18 tuổi trở lên và đồng ý với Điều khoản sử dụng cùng quy tắc nội dung.",
    "auth.idUpload": "Giấy tờ tùy thân (xác minh tuổi)",
    "auth.idUploadHint": "Bắt buộc khi đăng ký. Dùng để kiểm duyệt 18+.",
    "auth.idAdd": "Thêm giấy tờ của tôi",
    "auth.idAdded": "Đã thêm giấy tờ",
    "auth.forgot": "Quên mật khẩu?",
    "auth.reset": "Đặt lại mật khẩu",
    "auth.resetHint": "Nhập email để nhận liên kết đặt lại.",
    "auth.newPassword": "Mật khẩu mới",
    "auth.backToLogin": "Quay lại đăng nhập",
    "auth.welcome": "Chào mừng đến với MIHOD PAY!",
    "auth.tagline": "Chia sẻ ảnh riêng tư. Theo giá của bạn.",
    "auth.subtitle": "Gửi cho bạn bè một bức ảnh đã khóa. Chỉ mở khóa sau khi thanh toán — và bạn nhận 80% mỗi lần bán.",
    "auth.ageError": "Bạn phải xác nhận đủ 18 tuổi trở lên.",
    "auth.idError": "Vui lòng thêm giấy tờ tùy thân.",
    "auth.onlyAdults": "Chỉ dành cho người từ 18 tuổi.",
    "home.yourBalance": "Số dư của bạn",
    "home.recharge": "Nạp tiền",
    "home.received": "Ảnh đã nhận",
    "home.noPhotos": "Chưa có ảnh nào",
    "home.noPhotosHint": "Thêm bạn bè để nhận ảnh đã khóa.",
    "home.findFriends": "Tìm bạn bè",
    "home.count": "bài đăng",
    "explore.title": "Khám phá",
    "explore.searchPlaceholder": "Tìm nhà sáng tạo, #hashtag, âm thanh…",
    "explore.creators": "Nhà sáng tạo",
    "explore.hashtags": "Hashtag",
    "explore.sounds": "Âm thanh",
    "explore.trendingTags": "Hashtag thịnh hành",
    "explore.trendingSounds": "Âm thanh thịnh hành",
    "explore.suggested": "Nhà sáng tạo gợi ý",
    "explore.noResults": "Không có kết quả",
    "profile.title": "Hồ sơ",
    "profile.balance": "Số dư",
    "profile.earnings": "Thu nhập",
    "profile.sold": "Đã bán",
    "profile.private": "Tài khoản riêng tư",
    "profile.privateDesc": "Chỉ bạn bè mới có thể gửi ảnh cho bạn.",
    "profile.creatorSub": "Gói nhà sáng tạo",
    "profile.creatorSubDesc": "Truy cập hàng tháng vào tất cả ảnh của bạn (gói Stripe).",
    "profile.locked": "Đã khóa",
    "profile.subGate": "Mở khóa từ",
    "profile.subscribers": "người đăng ký — bạn có",
    "profile.language": "Ngôn ngữ",
    "profile.languageDesc": "Chọn ngôn ngữ giao diện.",
    "profile.avatarChange": "Đổi ảnh",
    "profile.publications": "Bài đăng",
    "profile.photosPublished": "Ảnh",
    "profile.videosPublished": "Video",
    "profile.myWall": "Xem tường công khai của tôi",
    "profile.subscribersCount": "Người đăng ký",
    "profile.mySubs": "Gói của tôi",
    "profile.yourSubscribers": "Người đăng ký của bạn",
    "profile.blocked": "Người dùng bị chặn",
    "profile.noBlocked": "Không có người dùng bị chặn.",
    "profile.unblock": "Bỏ chặn",
    "profile.tos": "Điều khoản sử dụng",
    "profile.safety": "An toàn & kiểm duyệt",
    "profile.logout": "Đăng xuất",
    "profile.kycPending": "Đang chờ xác minh danh tính",
    "profile.kycApproved": "Đã xác minh danh tính",
    "account.title": "Chỉnh sửa tài khoản",
    "account.desc": "Cập nhật tên người dùng, email hoặc mật khẩu.",
    "account.edit": "Chỉnh sửa",
    "account.info": "Thông tin",
    "account.currentPassword": "Mật khẩu hiện tại",
    "account.saveInfo": "Lưu",
    "account.changePassword": "Đổi mật khẩu",
    "account.infoSaved": "Đã cập nhật tài khoản",
    "account.passwordChanged": "Đã đổi mật khẩu",
    "send.title": "Gửi nội dung",
    "send.recipient": "Người nhận",
    "send.noFriends": "Không có bạn bè khả dụng",
    "send.add": "Thêm",
    "send.media": "Nội dung",
    "send.choosePhoto": "Chọn ảnh hoặc video",
    "send.formats": "JPG, PNG, MP4 • ảnh tối đa 8 MB",
    "send.changeMedia": "Đổi nội dung",
    "send.willLock": "Sẽ khóa ở",
    "send.price": "Giá mở khóa",
    "send.youEarn": "Bạn nhận được",
    "send.caption": "Chú thích (tùy chọn)",
    "send.captionPlaceholder": "Thêm một tin nhắn…",
    "send.submit": "Gửi nội dung đã khóa",
    "send.sending": "Đang gửi…",
    "send.noMax": "Không giới hạn giá — tối thiểu 1 €",
    "conv.start": "Bắt đầu trò chuyện hoặc gửi ảnh đã khóa.",
    "conv.write": "Viết tin nhắn…",
    "conv.requestPhoto": "Yêu cầu ảnh",
    "conv.sendPhoto": "Gửi ảnh",
    "conv.translating": "Đang dịch…",
    "wall.title": "Tường nhà sáng tạo của tôi",
    "wall.subtitle": "Đăng ảnh và video trả phí mà mọi người đều thấy.",
    "wall.publish": "Bài đăng mới",
    "wall.publishTo": "Đăng lên tường của tôi",
    "wall.empty": "Chưa có bài đăng.",
    "wall.emptyHint": "Thêm ảnh hoặc video trả phí đầu tiên của bạn.",
    "wall.visitVitrine": "Xem trang trưng bày của tôi",
    "wall.published": "Đã thêm bài đăng vào tường của bạn",
    "wall.creatorPage": "Trang nhà sáng tạo",
    "wall.posts": "bài đăng",
    "wall.subscribeToUnlock": "Đăng ký để mở khóa tất cả",
    "wall.notFound": "Không tìm thấy nhà sáng tạo",
    "wall.by": "Bài đăng của",
    "wallet.title": "Ví",
  },
  ko: {
    "common.loading": "불러오는 중…",
    "common.cancel": "취소",
    "common.save": "저장",
    "common.send": "보내기",
    "common.close": "닫기",
    "common.delete": "삭제",
    "common.subscribe": "구독",
    "common.subscribed": "구독함",
    "common.unlock": "잠금 해제",
    "common.locked": "잠김",
    "common.unlocked": "잠금 해제됨",
    "common.photo": "사진",
    "common.video": "동영상",
    "common.publish": "게시",
    "common.translate": "번역",
    "common.showOriginal": "원본 보기",
    "common.pleaseWait": "잠시 기다려 주세요…",
    "nav.home": "홈",
    "nav.friends": "친구",
    "nav.send": "보내기",
    "nav.wallet": "지갑",
    "nav.profile": "프로필",
    "nav.wall": "내 담벼락",
    "auth.login": "로그인",
    "auth.register": "회원가입",
    "auth.email": "이메일",
    "auth.password": "비밀번호",
    "auth.username": "사용자 이름",
    "auth.signIn": "로그인",
    "auth.createAccount": "계정 만들기",
    "auth.age": "저는 만 18세 이상임을 확인하며 이용약관과 콘텐츠 규칙에 동의합니다.",
    "auth.idUpload": "신분증 (연령 확인)",
    "auth.idUploadHint": "가입 시 필수입니다. 18+ 검수에 사용됩니다.",
    "auth.idAdd": "신분증 추가",
    "auth.idAdded": "신분증 추가됨",
    "auth.forgot": "비밀번호를 잊으셨나요?",
    "auth.reset": "비밀번호 재설정",
    "auth.resetHint": "재설정 링크를 받으려면 이메일을 입력하세요.",
    "auth.newPassword": "새 비밀번호",
    "auth.backToLogin": "로그인으로 돌아가기",
    "auth.welcome": "MIHOD PAY에 오신 것을 환영합니다!",
    "auth.tagline": "비공개 사진을 공유하세요. 당신의 가격으로.",
    "auth.subtitle": "친구에게 잠긴 사진을 보내세요. 결제 후에만 열리며, 판매마다 80%를 받습니다.",
    "auth.ageError": "만 18세 이상임을 확인해야 합니다.",
    "auth.idError": "신분증을 추가해 주세요.",
    "auth.onlyAdults": "만 18세 이상만 이용 가능합니다.",
    "home.yourBalance": "내 잔액",
    "home.recharge": "충전",
    "home.received": "받은 사진",
    "home.noPhotos": "아직 사진이 없습니다",
    "home.noPhotosHint": "잠긴 사진을 받으려면 친구를 추가하세요.",
    "home.findFriends": "친구 찾기",
    "home.count": "게시물",
    "explore.title": "탐색",
    "explore.searchPlaceholder": "크리에이터, #해시태그, 사운드 검색…",
    "explore.creators": "크리에이터",
    "explore.hashtags": "해시태그",
    "explore.sounds": "사운드",
    "explore.trendingTags": "인기 해시태그",
    "explore.trendingSounds": "인기 사운드",
    "explore.suggested": "추천 크리에이터",
    "explore.noResults": "결과 없음",
    "profile.title": "프로필",
    "profile.balance": "잔액",
    "profile.earnings": "수익",
    "profile.sold": "판매됨",
    "profile.private": "비공개 계정",
    "profile.privateDesc": "친구만 사진을 보낼 수 있습니다.",
    "profile.creatorSub": "크리에이터 구독",
    "profile.creatorSubDesc": "모든 사진에 월간 액세스 (Stripe 요금제).",
    "profile.locked": "잠김",
    "profile.subGate": "이 금액부터 잠금 해제",
    "profile.subscribers": "구독자 — 보유",
    "profile.language": "언어",
    "profile.languageDesc": "인터페이스 언어를 선택하세요.",
    "profile.avatarChange": "사진 변경",
    "profile.publications": "게시물",
    "profile.photosPublished": "사진",
    "profile.videosPublished": "동영상",
    "profile.myWall": "내 공개 담벼락 보기",
    "profile.subscribersCount": "구독자",
    "profile.mySubs": "내 구독",
    "profile.yourSubscribers": "내 구독자",
    "profile.blocked": "차단한 사용자",
    "profile.noBlocked": "차단한 사용자가 없습니다.",
    "profile.unblock": "차단 해제",
    "profile.tos": "이용약관",
    "profile.safety": "안전 및 검수",
    "profile.logout": "로그아웃",
    "profile.kycPending": "신원 확인 대기 중",
    "profile.kycApproved": "신원 확인 완료",
    "account.title": "계정 수정",
    "account.desc": "사용자 이름, 이메일 또는 비밀번호를 업데이트하세요.",
    "account.edit": "수정",
    "account.info": "정보",
    "account.currentPassword": "현재 비밀번호",
    "account.saveInfo": "저장",
    "account.changePassword": "비밀번호 변경",
    "account.infoSaved": "계정이 업데이트됨",
    "account.passwordChanged": "비밀번호가 변경됨",
    "send.title": "미디어 보내기",
    "send.recipient": "받는 사람",
    "send.noFriends": "사용 가능한 친구가 없습니다",
    "send.add": "추가",
    "send.media": "미디어",
    "send.choosePhoto": "사진 또는 동영상 선택",
    "send.formats": "JPG, PNG, MP4 • 사진 최대 8MB",
    "send.changeMedia": "미디어 변경",
    "send.willLock": "다음 금액에 잠깁니다",
    "send.price": "잠금 해제 가격",
    "send.youEarn": "받는 금액",
    "send.caption": "설명 (선택)",
    "send.captionPlaceholder": "메시지를 추가하세요…",
    "send.submit": "잠긴 미디어 보내기",
    "send.sending": "보내는 중…",
    "send.noMax": "가격 제한 없음 — 최소 1 €",
    "conv.start": "대화를 시작하거나 잠긴 사진을 보내세요.",
    "conv.write": "메시지 작성…",
    "conv.requestPhoto": "사진 요청",
    "conv.sendPhoto": "사진 보내기",
    "conv.translating": "번역 중…",
    "wall.title": "내 크리에이터 담벼락",
    "wall.subtitle": "모두가 볼 수 있는 유료 사진과 동영상을 게시하세요.",
    "wall.publish": "새 게시물",
    "wall.publishTo": "내 담벼락에 게시",
    "wall.empty": "아직 게시물이 없습니다.",
    "wall.emptyHint": "첫 유료 사진이나 동영상을 추가하세요.",
    "wall.visitVitrine": "내 쇼케이스 페이지 보기",
    "wall.published": "게시물이 담벼락에 추가됨",
    "wall.creatorPage": "크리에이터 페이지",
    "wall.posts": "게시물",
    "wall.subscribeToUnlock": "모두 잠금 해제하려면 구독하세요",
    "wall.notFound": "크리에이터를 찾을 수 없습니다",
    "wall.by": "게시자",
    "wallet.title": "지갑",
  },
};
